<template>
	<div class="w-100">
		<div class="text-center">
			<loading v-if="!smallScreen" :active.sync="showLoadingScreen" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
				<template slot="before">
					<div class="absolute text-lg loading-logo">
						<img src="/img/icon-512.png" height="20" width="20" class="d-inline-block align-top" alt="Grafias">
					</div>
				</template>
				<template slot="after">
					<div class="text-lg loading-text">{{ loadingCache }}</div>
					<div class="mt-2">
						<button class="btn btn-cancel" @click="onCancel">Skip Cache</button>
					</div>
				</template>
			</loading>
			<!-- loading screen on mobile -->
			<loading v-else :active.sync="isFetchingRundown" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
				<template slot="before">
					<div class="absolute text-lg loading-logo">
						<img src="/img/icon-512.png" height="20" width="20" class="d-inline-block align-top" alt="Grafias">
					</div>
				</template>
				<template slot="after">
					<div class="text-lg loading-text">{{ loadingCache }}</div>
				</template>
			</loading>
		</div>
		<div class="app-wrapper d-flex w-100" v-show="!showLoadingScreen">
			<!-- Sidebar -->
			<aside
				class="aside p-0"
				@mouseover="isHoverOnTheList = true"
				@mouseleave="isHoverOnTheList = false">
				<div class="aside-top">
					<!-- Add -->
					<button
						v-if="!smallScreen"
						type="button"
						class="btn btn-default btn-icon p-0"
						v-tooltip="$t('Add Asset')"
						:class="{'is-loading': isSaving || addingItem}"
						v-click-outside="hideContextAdd" @click="toggleContextAdd()" id="dropdownContextAdd">
						<i v-if="!isSaving && !addingItem" class="material-icons text-success">{{ $t('add') }}</i>
					</button>
					<ul v-if="addOpened" class="dropdown-context-add-item icon-menu-item">
						<li class="text-grey pl-4 pb-1 pt-2 pos-r">
							<span>{{ $t('Assets') }}<div class="absolute assets-divider"><mdDivider></mdDivider></div></span>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('lower_third')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Lower Third') }}</div>
								<div class="lower_third_icon_re"></div>
								<alpha-a-icon class="text-black icon-lt-menu" :size="20"></alpha-a-icon>
							</div>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('image')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Media') }}</div>
								<div>
									<image-icon class="rundown-icon type-image mr-3" :size="15"></image-icon>
								</div>
							</div>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('lottie')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Lottie') }}</div>
								<div>
									<transition-icon class="transition-icon type-lottie rundown-icon mr-3" :size="15"></transition-icon>
								</div>
							</div>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('timer')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Timer') }}</div>
								<div>
									<clock-icon class="clock-icon type-timer rundown-icon mr-3" :size="15"></clock-icon>
								</div>
							</div>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('ticker')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Ticker') }}</div>
								<div>
									<format-text-rotation-none-icon class="format-size-icon type-ticker rundown-icon mr-3" :size="15"></format-text-rotation-none-icon>
								</div>
							</div>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('audio')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Audio') }}</div>
								<div>
									<music-icon class="type-audio rundown-icon mr-3" :size="15"></music-icon>
								</div>
							</div>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('separator')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Marker') }}</div>
								<div>
									<ray-start-end-icon class="earth-icon type-custom_page rundown-icon mr-3" :size="15"></ray-start-end-icon>
								</div>
							</div>
						</li>
						<li class="text-grey pl-4 pb-1 pt-2 pos-r">
							<span>{{ $t('Capture') }}<div class="absolute capture-divider"><mdDivider></mdDivider></div></span>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('video_input')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Video Input') }}</div>
								<div>
									<video-icon class="video-icon type-video_input rundown-icon mr-3" :size="15"></video-icon>
								</div>
							</div>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('composition')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Composition') }}</div>
								<div>
									<view-compact-icon class="picture-in-picture-bottom-right-outline-icon type-composition rundown-icon mr-3" :size="15"></view-compact-icon>
								</div>
							</div>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('custom_page')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Browser Source') }}</div>
								<div>
									<earth-icon class="earth-icon type-custom_page rundown-icon mr-3" :size="15"></earth-icon>
								</div>
							</div>
						</li>
						<!-- <li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('virtual_cam')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Virtual Cam') }}</div>
								<div>
									<webcam-icon class="webcam-icon type-virtual_cam rundown-icon mr-3" :size="15"></webcam-icon>
								</div>
							</div>
						</li> -->
						<!-- <li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('lightstream_rtmp')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Lightstream RTMP') }}</div>
								<div>
									<video-icon class="type-lightstream_rtmp rundown-icon mr-3" :size="15"></video-icon>
								</div>
							</div>
						</li> -->
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('custom_command')">
							<div class="justify-content-between d-flex">
								<div>{{ $t('Custom Command') }}</div>
								<div>
									<cube-icon class="rundown-icon mr-3" :size="15"></cube-icon>
								</div>
							</div>
						</li>
						<!-- <li class="text-white-context pl-4 pb-2 pt-2"
							@click="addItem('zoom_meeting')">
							<div class="justify-content-between d-flex">
								<div>
									{{ $t('Zoom Meeting') }}
								</div>
								<div>
									<radio-tower-icon class="radio-tower-icon type-zoom_meeting rundown-icon mr-3" :size="15"></radio-tower-icon>
								</div>
							</div>
						</li> -->
					</ul>

					<!-- Filter -->
					<button
						v-if="!smallScreen"
						type="button"
						class="btn btn-default btn-icon p-0"
						v-tooltip="$t('Filter')"
						v-click-outside="hideContextFilter" @click="toggleContextFilter()" id="dropdownContextFilter"
						:disabled="isEmpty">
						<i class="material-icons">filter_list</i>
					</button>
					<ul v-if="filterOpened" class="dropdown-context-filter-item">
						<li
							class="flex-center text-white-context pl-4 pb-2 pt-2"
							v-for="itemType in itemTypes"
							:key="itemType.key"
							@click="filter(itemType.key)">
							<span>{{ $t(itemType.label) }}</span>
							<i class="material-icons text-white md-18 ml-auto pr-4" v-if="filterType === itemType.key">check</i>
						</li>
					</ul>

					<!-- Search -->
					<div class="form-group search mb-0">
						<input
							type="text"
							class="form-control"
							:placeholder="$t('Search')"
							@input="onKeywordChange"
							v-model="keyword"
							@focus="focusOnSearch(true)"
							@blur="focusOnSearch(false)"
						/>
					</div>

					<!-- Button show macro & assets list mobile -->
					<button
						v-if="smallScreen && showAssets"
						v-click-outside="hideContextStopAll" @contextmenu.prevent @contextmenu="toggleContextStopAll()" ref="dropdownContextStopAll"
						type="button"
						class="btn btn-default btn-icon p-0 ml-a btn-mobile-rundown"
						@click="showAssets = false">
						<img src="/img/script-text.png" height="15" width="15" class="navbar-brand-composition" alt="Grafias">
					</button>
					<button
						v-if="smallScreen && !showAssets"
						v-click-outside="hideContextStopAll" @contextmenu.prevent @contextmenu="toggleContextStopAll()" ref="dropdownContextStopAll"
						type="button"
						class="btn btn-default btn-icon p-0 ml-a btn-mobile-rundown"
						@click="showAssets = true">
						<i class="material-icons text-green md-18 pl-1">playlist_play</i>
					</button>

					<!-- Stop -->
					<button
						v-click-outside="hideContextStopAll" @contextmenu.prevent @contextmenu="toggleContextStopAll()" ref="dropdownContextStopAll"
						type="button"
						class="btn btn-default btn-icon p-0 btn-mobile-rundown"
						:disabled="isEmpty"
						@click="stopAllAction"
						v-tooltip="$t('Stop All')">
						<i class="material-icons text-danger">stop</i>
					</button>
					<ul v-if="stopAllOpened" class="dropdown-context-rundown-stop-all text-left">
						<li class="text-white-context pl-4 pb-2 pt-2" @click="stopAllLive">
							{{$t('Stop All LIVE')}}
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2" @click="stopAllPreview">
							{{$t('Stop All PREVIEW')}}
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2" @click="copyStopUrl('stopall')">
							{{$t('Copy Stop All URL')}}
						</li>
					</ul>

					<!-- Settings -->
					<button
						v-if="!smallScreen"
						type="button"
						class="btn btn-default btn-icon p-0"
						v-tooltip="$t('Settings')"
						v-click-outside="hideContextSettings" @click="toggleContextSettings()" id="dropdownContextSettings">
						<i class="material-icons">settings</i>
					</button>
					<ul v-if="settingsOpened" class="dropdown-context-settings-item">
						<!-- swith command -->
						<li class="text-white-context pl-4 pb-2 pt-2"
							@click="goToCommandRundown()">
							{{ $t('Command View') }}
						</li>
						<!-- All -->
						<li class="text-white-context pl-4 pb-2 pt-2"
							:disabled="isEmpty || !display"
							@click="stopAll">
							{{ $t('Clear Output') }}
						</li>
						<!-- Lower Third -->
						<li class="text-white-context pl-4 pb-2 pt-2" @click="isRenameVisible = true">
							{{ $t('Rename Rundown') }}
						</li>
						<!-- Lower Third -->
						<li v-if="rundownUserId === user.id">
							<button class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
							:disabled="filteredItems.length <= 0" @click="openConfirmDeleteAll"
							>{{ $t('Clear Rundown') }}</button>
						</li>
						<!-- Export Rundown-->
						<li>
							<button
							type="button"
							class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
							:disabled="filteredItems.length <= 0"
							:class="{ 'is-loading': isExporting }"
							@click="exportItems('excel')">
							{{ $t('Export Rundown') }}
							</button>
						</li>
						<!--  Render menu -->
						<li @mouseover="showRender = true" @mouseleave="showRender = false">
							<button
								disabled
								onclick="return false;"
								type="button"
								style="cursor: default!important"
								class="flex-center w-100 btn-item-context pl-4 pb-2 pt-2"
								>
								<span class="w-140 text-left fs-13px">{{ $t('Render Rundown') }}</span>
								<i class="material-icons text-white md-18 ml-auto">keyboard_arrow_right</i>
							</button>
							<ul v-if="showRender" class="dropdown-context-render-rundown">
								<li v-if="userRenderSequences" @click="confirmRender('image')" class="text-white-context pl-4 pb-2 pt-2 pointer" :class="{'is-loading': isFetchingRundown}" >
									{{ $t('Image Sequence') }}
								</li>
								<li v-if="userRenderSequences" @click="confirmRender('video')" class="text-white-context pl-4 pb-2 pt-2 pointer" :class="{'is-loading': isFetchingRundown}" >
									{{ $t('Video') }}
								</li>
								<li v-if="userRenderSequences" @click="confirmRender('merged_video')" class="text-white-context pl-4 pb-2 pt-2 pointer" :class="{'is-loading': isFetchingRundown}" >
									{{ $t('Render All as Single Video') }}
								</li>
								<li v-if="userRenderSequences" @click="copyURLitem('renderall')" class="text-white-context pl-4 pb-2 pt-2 pointer" :class="{'is-loading': isFetchingRundown, 'disabled-item': filteredItems.length <= 0}" >
									{{ $t('Copy Render Rundown URL') }}
								</li>
								<!-- if user hasnt render subscription (add tooltip subscription information)-->
								<li v-if="!userRenderSequences" @click.stop="" class="text-white-context bg-grey-second pl-4 pb-2 pt-2 pointer" v-tooltip="{ content: 'Upgrade your subscription for this feature', classes: 'tooltip-render-information', placement: 'left'}">
									<div class="text-disabled">{{ $t('Image Sequence') }}</div>
								</li>
								<li v-if="!userRenderSequences" @click.stop="" class="text-white-context bg-grey-second pl-4 pb-2 pt-2 pointer" v-tooltip="{ content: 'Upgrade your subscription for this feature', classes: 'tooltip-render-information', placement: 'left'}">
									<div class="text-disabled">{{ $t('Video') }}</div>
								</li>
								<li v-if="!userRenderSequences" @click.stop="" class="text-white-context bg-grey-second pl-4 pb-2 pt-2 pointer" v-tooltip="{ content: 'Upgrade your subscription for this feature', classes: 'tooltip-render-information', placement: 'left'}">
									<div class="text-disabled">{{ $t('Render All as Single Video') }}</div>
								</li>
								<li v-if="!userRenderSequences" @click.stop="" class="text-white-context bg-grey-second pl-4 pb-2 pt-2 pointer" v-tooltip="{ content: 'Upgrade your subscription for this feature', classes: 'tooltip-render-information', placement: 'left'}">
									<div class="text-disabled">{{ $t('Copy Render Rundown URL') }}</div>
								</li>
							</ul>
						</li>
						<!-- Import Rundown -->
						<li>
							<button
								type="button"
								class="text-left pl-4 w-100 btn-item-context pt-2"
								:class="{ 'is-loading': isImporting }"
								>
								<label class="text-left w-100 btn-item-context"
								:class="{ 'is-loading': isImporting }">
									<span class="fs-13px">{{ $t('Import Rundown') }}</span>
									<input
										accept=".xlsx, .xls"
										type="file"
										class="hidden"
										@change="onImportSelected"
									/>
								</label>
							</button>
						</li>
						<!-- Import Lower Third Data -->
						<li>
							<button
								type="button"
								class="text-left pl-4 w-100 btn-item-context pt-2"
								:class="{ 'is-loading': isImporting }"
								@click="isShowImportLowerThird = true">
								<label class="text-left w-100 btn-item-context" :class="{ 'is-loading': isImporting }">
									<span class="fs-13px">{{ $t('Import Lower Third Data') }}</span>
								</label>
							</button>
						</li>
						<!-- Hide Shy Items -->
						<li>
							<button
								type="button"
								class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
								:disabled="!hasShyItems"
								@click="filterShy = !filterShy">
								{{ $t('Hide Shy Assets') }}
								<i class="material-icons text-white md-18 ml-auto" v-if="filterShy">check</i>
							</button>
						</li>
						<!-- force recache media -->
						<li>
							<button
								type="button"
								:disabled="filteredItems.length <= 0"
								class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
								@click="rebuildCache()">
								{{ $t('Rebuild Cache') }}
							</button>
						</li>

						<!-- force recache media
						<li>
							<button
								type="button"
								:disabled="filteredItems.length <= 0"
								class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
								@click="exampleChekAxios()">
								{{ $t('check only will delete soon') }}
							</button>
						</li> -->
						<!-- force recache media -->
						<li>
							<button
								type="button"
								:disabled="filteredItems.length <= 0"
								class="text-white-context pb-2 pt-5px btn btn-item-rundown-item "
								@click="cacheDisplays()">
								{{ $t('Rebuild Cache on Displays') }}
							</button>
						</li>
						<!--  canvas menu -->
						<li @mouseover="showBackgroundColor = true" @mouseleave="showBackgroundColor = false">
							<button
								disabled
								onclick="return false;"
								type="button"
								style="cursor: default!important"
								class="flex-center w-100 btn-item-context pl-4 pb-2 pt-2"
								>
								<span class="w-140 text-left fs-13px">{{ $t('Canvas Background') }}</span>
								<i class="material-icons text-white md-18 ml-auto">keyboard_arrow_right</i>
							</button>
							<ul v-if="showBackgroundColor" class="dropdown-context-settings-background">
								<li @click="changeBackground('#000000')" class="text-white-context pl-4 pb-2 pt-2 pointer">
									{{ $t('Luma (Black)') }}
								</li>
								<li @click="changeBackground('#00FF00')" class="text-white-context pl-4 pb-2 pt-2 pointer">
									{{ $t('Chroma (Green)') }}
								</li>
								<li @click="changeBackground('#FFFFFF')" class="text-white-context pl-4 pb-2 pt-2 pointer">
									{{ $t('Transparent (Alpha)') }}
								</li>
							</ul>
						</li>
						<!-- misc -->
						<li>
							<button
								type="button"
								class="text-white-context pb-2 pt-5px btn btn-item-rundown-item "
								@click="openMisc()">
								{{ $t('Misc File') }}
							</button>
						</li>
						<!-- Switch Editor Layout -->
						<!-- <li
							:disabled="isEmpty"
							@click="filter('export')">
							{{ $t('Switch Editor Layout') }}
						</li> -->
					</ul>
				</div>
				<div class="aside-main custom-scroll item-rundown-wrapper" v-if="showAssets"
					:class="{'item-rundown-wrapper-many-macros': macros.length > 7}"
					@contextmenu.prevent
					@scroll.passive="handleScroll"
					v-click-outside="unClickedListRundownItem">
					<draggable
						v-model="filteredItems"
						v-bind="dragOptions"
						@start="drag = true"
						@end="drag = false"
						@change="changeDragAndDrop"
						:sort="isPlayingMacroListDone"
						handle=".item-handler">
						<transition-group
							class="rundown-items"
							type="transition"
							:name="!drag ? 'flip-list' : null">
							<div v-for="(item, index) in filteredItems" :key="`rundownItem_${index}`">
								<rundown-item
									v-if="item.name"
									:class="{'hidden': filterShy && item.is_shy}"
									:rundown="item"
									:rundownSlug="slug"
									:selectedItem="selectedItem"
									@edit="editItem"
									@editLtMobile="editLtMobile"
									@update="updateItem"
									@duplicate="duplicateItem"
									@setSelectedItem="setSelectedItem"
									@remove="confirmDeleteItem"
									@previewClick="editItem"
									@clickItem="clickItem"
									:scrollVisible="isScrollItem"
									:closeContextItem="closeContextItem"
									:isPlayingMacroListDone="isPlayingMacroListDone"
									:visibleElements="visibleElements"
									:keyword="keyword"
									@reorder="reorder"
									:currentIndex="index+1"
									:totalItems="filteredItems.length"
									:typeNextItem="filteredItems[index+1] ? filteredItems[index+1].type : ''"
									:itemsWithGroupId="itemsWithGroupId"
									>
								</rundown-item>
							</div>
						</transition-group>
					</draggable>
					<div class="d-flex btn-click-add-item" v-if="!isFetchingItems">
						<!-- Add -->
						<md-menu
							v-if="!smallScreen"
							class="h-fc pt-1 pb-1"
							:md-offset-x="10"
							md-align-trigger>
							<button
								type="button"
								class="btn-icon btn p-0 m-0 w-100 btn-click"
								md-menu-trigger>
								<i v-if="isSaving || addingItem" class="is-loading"></i>
								<i v-if="!isSaving && !addingItem" class="material-icons text-white relative">{{ $t('add') }}</i>
								<span v-if="!isSaving && !addingItem" class="pointer text-white text-btn">{{$t('Click to add Asset')}}</span>
							</button>
							<md-menu-content class="minw-200 icon-menu-item-down">
								<md-menu-item class="pos-r">
								<div class="text-grey uppercase pb-1 pt-2">
									{{ $t('Assets') }}<div class="absolute assets-divider-2"><mdDivider></mdDivider></div>
								</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('lower_third')">
									<div class="alternative">
										{{ $t('Lower Third') }}
										<div class="lower_third_icon_down absolute"></div>
										<alpha-a-icon class="icon-lt-down" :size="20"></alpha-a-icon>
									</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('image')">
									<div class="alternative">
										{{ $t('Media') }}
										<image-icon class="image-icon type-image rundown-icon mr-mr12" :size="15"></image-icon>
									</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('lottie')">
									<div class="alternative">
										{{ $t('Lottie') }}
										<transition-icon class="transition-icon type-lottie rundown-icon mr-mr12" :size="15"></transition-icon>
									</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('timer')">
									<div class="alternative">
										{{ $t('Timer') }}
										<clock-icon class="clock-icon type-timer rundown-icon mr-mr12" :size="15"></clock-icon>
									</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('ticker')">
									<div class="alternative">
										{{ $t('Ticker') }}
										<format-text-rotation-none-icon class="format-size-icon type-ticker rundown-icon mr-mr12" :size="15"></format-text-rotation-none-icon>
									</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('audio')">
									<div class="alternative">
										{{ $t('Audio') }}
											<music-icon class="music-icon type-audio rundown-icon mr-mr12" :size="15"></music-icon>
									</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('separator')">
									<div class="alternative">
										{{ $t('Marker') }}
										<ray-start-end-icon class="earth-icon type-custom_page rundown-icon mr-mr12" :size="15"></ray-start-end-icon>
									</div>
								</md-menu-item>
								<md-menu-item class="pos-r">
								<div class="text-grey uppercase pb-1 pt-2">
										{{ $t('Capture') }}<div class="absolute capture-divider-2"><mdDivider></mdDivider></div>
								</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('video_input')">
									<div class="alternative">
										{{ $t('Video Input') }}
										<video-icon class="video-icon type-video_input rundown-icon mr-mr12" :size="15"></video-icon>
									</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('composition')">
									<div class="alternative">
										{{ $t('Composition') }}
										<view-compact-icon class="picture-in-picture-bottom-right-outline-icon type-composition rundown-icon mr-mr12" :size="15"></view-compact-icon>
									</div>
								</md-menu-item>
								<md-menu-item
									@click="addItem('custom_page')">
									<div class="alternative">
										{{ $t('Browser Source') }}
										<earth-icon class="earth-icon type-custom_page rundown-icon mr-mr12" :size="15"></earth-icon>
									</div>
								</md-menu-item>
								<!-- <md-menu-item
									@click="addItem('virtual_cam')">
									<div class="alternative">
										{{ $t('Virtual Cam') }}
											<webcam-icon class="webcam-icon type-virtual_cam rundown-icon mr-mr12" :size="15"></webcam-icon>
									</div>
								</md-menu-item> -->
								<!-- <md-menu-item
									@click="addItem('lightstream_rtmp')">
									<div class="alternative">
										{{ $t('Lightstream RTMP') }}
											<video-icon class="type-lightstream_rtmp rundown-icon mr-mr12" :size="15"></video-icon>
									</div>
								</md-menu-item> -->
								<md-menu-item
									@click="addItem('custom_command')">
									<div class="alternative">
										{{ $t('Custom Command') }}
											<cube-icon class="cube-icon type-custom_command rundown-icon mr-mr12" :size="15"></cube-icon>
									</div>
								</md-menu-item>
								<!-- <md-menu-item
									@click="addItem('zoom_meeting')">
									<div class="alternative">
										{{ $t('Zoom Meeting') }}
										<radio-tower-icon class="radio-tower-icon type-zoom_meeting rundown-icon mr-mr12" :size="15"></radio-tower-icon>
									</div>
								</md-menu-item> -->
							</md-menu-content>
						</md-menu>
					</div>
					<!-- Fetch Loader -->
					<div class="p-3 text-center w-100 mt-2" v-if="isFetchingItems">
						<div class="is-loading"></div>
					</div>
					<!-- Delete Confirmation -->
					<modal
						size="small"
						@close="closeModalConfirmDelete"
						v-if="isConfirmDeleteVisible && selectedItem">
						<template slot="header">
							{{ $t('Remove Asset') }}
						</template>
						<template slot="body">
							A<span class="lowercase pr-1">{{ $t('re you sure want to delete') }}</span><span class="capitalize">{{showModalName(selectedItem.name)}}?</span>
						</template>
						<template slot="footer">
							<div class="w-100 flex-center">
								<button class="btn btn-primary" :class="{ 'is-loading': isDeleting }" @click="deleteItem(selectedItem)">
									{{ $t('Yes, Proceed') }}
								</button>
								<button class="btn btn-default" @click="closeModalConfirmDelete">
									{{ $t('Cancel') }}
								</button>
							</div>
						</template>
					</modal>
					<!-- Delete Confirmation mobile -->
					<modal-bottom-sheet
						size="full"
						@close="closeModalConfirmDelete"
						:hideCloseButton="true"
						v-if="isConfirmDeleteMobileVisible && selectedItem">
						<template slot="header">
							{{ $t('Remove Asset') }}
						</template>
						<template slot="body">
							A<span class="lowercase pr-1">{{ $t('re you sure want to delete') }}</span><span class="capitalize">{{showModalName(selectedItem.name)}}?</span>
						</template>
						<template slot="footer">
							<div class="w-100 flex-center">
								<button class="btn btn-default" @click="closeModalConfirmDelete">
									{{ $t('Cancel') }}
								</button>
								<button class="btn btn-primary" :class="{ 'is-loading': isDeleting }" @click="deleteItem(selectedItem)">
									{{ $t('Yes, Proceed') }}
								</button>
							</div>
						</template>
					</modal-bottom-sheet>
					<!-- stop all Confirmation mobile -->
					<modal-bottom-sheet
						size="full"
						:hideCloseButton="true"
						v-if="showModalConfirmStopAll">
						<template slot="header">
							{{ $t('Confirm Stop All Rundown') }}
						</template>
						<template slot="body">
							<span class="tf-none pr-1">{{ $t('Stop all rundown, both PREVIEW and LIVE will be stopped') }}</span>
						</template>
						<template slot="footer">
							<div class="w-100 flex-center">
								<button class="btn btn-default" @click="showModalConfirmStopAll = false">
									{{ $t('Cancel') }}
								</button>
								<button class="btn btn-primary" :class="{ 'is-loading': isStopping }" @click="stopAll">
									{{ $t('Yes, Proceed') }}
								</button>
							</div>
						</template>
					</modal-bottom-sheet>
				</div>
				<!-- show list macros on mobile -->
				<div v-if="!showAssets">
					<div class="grid-container-macro">
						<div v-for="(macro, index) in macros" :key="macro.id">
							<div class="grid-item-macro" @click="playMacro(macro)">
								<div class="number-macro-text mb-0 disabled">{{ index + 1 }}</div>
								<div class="macro-text disabled">{{macro.name}}</div>
							</div>
						</div>
					</div>
					<div v-if="macros.length === 0">
						<div class="text-center">{{$t('No macro available')}}</div>
					</div>
				</div>
				<div class="aside-bottom mt-auto pl-7px" v-if="!smallScreen">
					<button
						@click="addMacro"
						type="button"
						class="btn-add-macro btn btn-info p-0 mb-0"
						:class="{ 'is-loading': isAddingMacro, 'disabled-w-bg': macros.length === 14, 'btn-add-macro-expand': macros.length > 7}">
						<!-- Temp Icon -->
						<!-- <i class="material-icons mr-2" v-tooltip="$t('Macros List')" @click="showMacrosList">format_list_bulleted</i> -->
						<img src="/img/script-text-white.png" width="18" class="material-icons" v-tooltip="$t('Add Macro')" @shortkey="addMacro" v-shortkey="{up: ['ctrl', 'shift', 'm'], down: ['ctrl', 'm']}">
					</button>
					<!-- <div class="d-flex wrapper-button-list-macro absolute" id="styleScroll"> -->
						<div :class="{'wrapper': macros.length > 7, 'd-flex': macros.length < 8}">
							<div v-for="(macro, index) in macros" :key="macro.id">
								<macro-button
									:index="index"
									:macros="macros"
									:macro="macro"
									:opened="opened"
									:macroActiveId="macroActiveId"
									@confirmRemoveVisibleMacro="confirmRemoveVisibleMacro"
									@showMacro="showMacro"
									@playMacro="playMacro"
									@duplicate="duplicate"
									@copyPlayMacro="copyPlayMacro"
									:macroId="macroId"
									:isFetchingMacros="isFetchingMacros"
									:customStyle="macros && macros.length < 8 ? 'margin-left: 2px' : ''"
								>
								</macro-button>
							</div>
						</div>
					<!-- </div> -->
				</div>
			</aside>

			<!-- Lower Third Prop -->
			<lower-third-property
				:media="media"
				:template="template"
				:rundown="rundown"
				:data="selectedItem"
				:filteredItems="filteredItems"
				:items="items"
				@add="onAddItem"
				@browse="openTemplate"
				@browseMedia="openGallery"
				@setTemplate="setTemplate"
				v-if="isLowerThirdFormVisible && !smallScreen">
			</lower-third-property>

			<!-- Lower Third Prop mobile -->
			<lower-third-property-mobile
				:media="media"
				:template="template"
				:rundown="rundown"
				:data="selectedItem"
				:filteredItems="filteredItems"
				:items="items"
				@close="isLowerThirdFormMobileVisible = false"
				@add="onAddItem"
				@browse="openTemplate"
				@browseMedia="openGallery"
				@setTemplate="setTemplate"
				v-if="isLowerThirdFormMobileVisible && smallScreen">
			</lower-third-property-mobile>

			<!-- Blank property -->
			<blank-property
				:data="!selectedItem"
				v-if="isBlankProperty && !smallScreen">
			</blank-property>

			<!-- Media Prop -->
			<media-property
				:media="media"
				:rundown="rundown"
				:data="selectedItem"
				@add="onAddItem"
				@browse="openGallery"
				:filteredItems="filteredItems"
				:items="items"
				v-if="isMediaFormVisible && !smallScreen">
			</media-property>

			<!-- lottie Prop -->
			<lottie-property
				:media="media"
				:rundown="rundown"
				:data="selectedItem"
				@add="onAddItem"
				@browse="openGallery"
				:filteredItems="filteredItems"
				:items="items"
				:disabled="isDisableItem"
				v-if="isLottieFormVisible && !smallScreen">
			</lottie-property>

			<!-- Composition Prop -->
			<composition-property
				:rundown="rundown"
				:data="selectedItem"
				@add="onAddItem"
				:filteredItems="filteredItems"
				:items="items"
				v-if="isCompositionFormVisible && !smallScreen">
			</composition-property>

			<!-- Zoom Prop -->
			<zoom-property
				:rundown="rundown"
				:data="selectedItem"
				@add="onAddItem"
				:filteredItems="filteredItems"
				:items="items"
				v-if="isZoomFormVisible && !smallScreen">
			</zoom-property>

			<!-- Browser Source Prop -->
			<custom-page-property
				:rundown="rundown"
				:data="selectedItem"
				@add="onAddItem"
				:filteredItems="filteredItems"
				:items="items"
				v-if="isCustomPageFormVisible && !smallScreen">
			</custom-page-property>

			<!--videoInput Prop -->
			<video-input-property
				:rundown="rundown"
				:data="selectedItem"
				@add="onAddItem"
				:filteredItems="filteredItems"
				:items="items"
				v-if="isVideoInputFormVisible && !smallScreen">
			</video-input-property>

			<!-- Ticker Prop -->
			<ticker-property
				:rundown="rundown"
				:template="template"
				:data="selectedItem"
				@add="onAddItem"
				@setTemplate="setTemplate"
				@browse="openTemplate"
				:filteredItems="filteredItems"
				:items="items"
				v-if="isTickerFormVisible && !smallScreen">
			</ticker-property>

			<!-- Timer Prop -->
			<timer-property
				:rundown="rundown"
				:template="template"
				:data="selectedItem"
				@add="onAddItem"
				@setTemplate="setTemplate"
				@browse="openTemplate"
				:items="items"
				:filteredItems="filteredItems"
				v-if="isTimerFormVisible && !smallScreen">
			</timer-property>

			<!-- separator marker property -->
			<separator-property
				:rundown="rundown"
				:template="template"
				:data="selectedItem"
				@add="onAddItem"
				@setTemplate="setTemplate"
				@browse="openTemplate"
				:items="items"
				:filteredItems="filteredItems"
				v-if="isSeperatorVisible && !smallScreen">
			</separator-property>

			<!-- virtual cam property -->
			<virtual-cam-property
				:virtualCamsData="virtualCamsData"
				:virtualCamData="virtualCam"
				:media="media"
				:template="template"
				:rundown="rundown"
				:data="selectedItem"
				:filteredItems="filteredItems"
				:items="items"
				@add="onAddItem"
				@browse="openTemplate"
				@browseMedia="openGallery"
				@setTemplate="setTemplate"
				v-if="isVirtualCamVisible && !smallScreen">
			</virtual-cam-property>

			<!-- custom command property -->
			<custom-command-property
				:rundown="rundown"
				:data="selectedItem"
				:filteredItems="filteredItems"
				:items="items"
				@add="onAddItem"
				v-if="isCustomCommandVisible && !smallScreen">
			</custom-command-property>

			<!-- audio property -->
			<audio-property
				:media="media"
				:rundown="rundown"
				:data="selectedItem"
				:filteredItems="filteredItems"
				:items="items"
				@add="onAddItem"
				@browse="openGallery"
				v-if="isAudioVisible && !smallScreen">
			</audio-property>

			<!-- audio property -->
			<rtmp-property
				:rundown="rundown"
				:data="selectedItem"
				:filteredItems="filteredItems"
				:items="items"
				@add="onAddItem"
				v-if="isRtmpVisible && !smallScreen">
			</rtmp-property>
			<!-- Stream -->
			<div id="containerCanvas" class="containerCanvasRundown relative">
				<!-- direction of live & preview reversed if display is vertical -->
				<div class="editor-main absolute" :class="{'d-flex flex-direction-reverse': displayHeight > displayWidth}" ref="editorMain" v-if="!smallScreen">
					<div
						class="stream-preview"
						:class="{'ml-1 mr-a': displayHeight > displayWidth}"
						:style="streamPreviewStyle">
						<div
							class="stream-preview-wrapper"
							:style="streamWrapperStyle">
							<div class="p-8 text-center w-100 mt-2 color-white"  v-if="!showIframe">
								<div class="is-loading loading-iframe"></div>
							</div>
							<iframe
								class="iframe-stream-preview no-highlight"
								v-show="showIframe && !isChangingBg"
								@load="showOnLoad()"
								frameBorder="0"
								:src="liveUrl"
								id="iframeLiveEditor">
							</iframe>
						</div>
						<div class="stream-type bg-danger">{{ $t('Live') }}</div>
					</div>
					<div
						class="stream-preview"
						:style="streamPreviewStyle">
						<div
							class="stream-preview-wrapper"
							:style="streamWrapperStyle">
							<div class="p-8 text-center w-100 mt-2 color-white"  v-if="!showIframe">
								<div class="is-loading loading-iframe"></div>
							</div>
							<iframe
								v-show="showIframe && !isChangingBg"
								class="iframe-stream-preview no-highlight"
								@load="showOnLoad()"
								frameBorder="0"
								:src="iframeUrl('preview')"
								id="iframePreviewEditor">
							</iframe>
						</div>
						<div class="stream-type bg-success">{{ $t('Preview') }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modals">
			<!-- Template -->
			<template-popup
				:rundownItem="selectedItem"
				@select="onTemplateSelected"
				@close="isTemplateVisible = false"
				@goToTemplatesEditor="closeModalTemplate"
				v-if="isTemplateVisible"
			/>

			<!-- Gallery -->
			<gallery-popup
				:rundown="rundown"
				:rundownItem="selectedItem"
				@select="onGallerySelected"
				@close="isGalleryVisible = false"
				@deleteMedia="updateSelectedItem"
				v-if="isGalleryVisible"
			/>


			<!-- Rename Rundown -->
			<modal
				size="small"
				@close="isRenameVisible = false"
				v-if="isRenameVisible">
				<template slot="header">
					{{ $t('Rename Rundown') }}
				</template>
				<template slot="body">
					<div class="form-group mb-3">
						<input
							type="text"
							class="form-control"
							:placeholder="$t('Rundown Name')"
							v-model="rundownName"
						/>
					</div>
				</template>
				<template slot="footer">
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isSavingRundown }"
						@click="updateRundown">
						{{ $t('Save') }}
					</button>
					<button
						type="button"
						class="btn btn-default"
						@click="isRenameVisible = false">
						{{ $t('Cancel') }}
					</button>
				</template>
			</modal>

			<!-- Clear All Rundown -->
			<modal
				size="small"
				@close="closeConfirmDeleteAll"
				v-if="isConfirmClearAll">
				<template slot="header">
					{{ $t('Clear All Rundown') }}
				</template>
				<template slot="body">
					{{$t('Are you sure to delete all item in this rundown?')}}
				</template>
				<template slot="footer">
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isDeletingAllRundown }"
						@click="bulkDelete">
						{{ $t('Proceed') }}
					</button>
					<button
						type="button"
						class="btn btn-default"
						@click="closeConfirmDeleteAll">
						{{ $t('Cancel') }}
					</button>
				</template>
			</modal>
			<!-- Modal Import Lower Third Data -->
			<modal-import-lower-third v-if="isShowImportLowerThird"
				:isShowModal="isShowImportLowerThird"
				@fetchItems="onImportLowerThirdComplete"
				@close="closeModalLowerThird"
				:rundown="rundown"
				:templateItems="templates" >
				{{ $t('Select File') }}
			</modal-import-lower-third>
			<!-- Macros List -->
			<modal
				class="macro-list-modal"
				size="small-medium"
				:hide-footer="true"
				@close="isMacrosListVisible = false"
				v-if="isMacrosListVisible">
				<template slot="header">
					<div>{{ $t('Macros List') }}</div>
				</template>
				<template slot="body">
					<div v-if="macros.length === 0" class="text-center">
						{{$t('No macro available')}}
					</div>
					<draggable
						v-model="macros"
						v-bind="dragOptions"
						@start="drag = true"
						@end="drag = false"
						@change ="onMacrosOrderChanged">
						<transition-group
							class="macros-list"
							type="transition"
							:name="!drag ? 'flip-list' : null">
							<div
								class="macro cur-p"
								v-for="(macro, index) in macros"
								:key="macro.id"
								@click="showMacro(macro)">
								<span class="mr-2">{{ index + 1 }}.</span>
								<span>{{ macro.name }}</span>
							</div>
						</transition-group>
					</draggable>
					<div class="text-right">
						<button @click="addMacro"
							type="button"
							class="btn btn-blue mt-4"
							:class="{ 'is-loading': isAddingMacro }">
							<!-- Temp Icon -->
							Add Macro
						</button>
					</div>
				</template>
			</modal>
			<modal-take-over
				@close="closeTakeOver"
				:isShowTakeOver="isShowTakeOver"
			/>
			<!-- Macro -->
			<macro-modal
				:rundown="rundown"
				@fetch="fetchItemsNotSeparator"
				:rundown-items="itemsNotSeparator"
				:data="selectedMacro"
				@remove="removeMacro"
				@save="insertMacro"
				@update="updateMacro"
				@duplicate="onMacroDuplicated"
				@close="isMacroVisible = false"
				v-if="isMacroVisible"
				:macros="macros"
			/>
			<ModalFetchDisplayCache @close="closeDisplayCache" v-if="isShowDisplayCache">
				<template slot="header">
					<h5>Display output cache</h5>
				</template>
				<template slot="body">
					<div class="w-210">
						<div class="main-modal-composition">
						<div>
							<div class="mt-2">
								<h6 v-if="isShowDisplayCache && !displayCacheList || displayCacheList.length <= 0"> No Display Caching Process</h6>
								<div v-for="(cacheItem, index) in displayCacheList" :key="`${index}_${cacheItem.name}`" class="d-flex justify-content-between">
									<h6> {{ cacheItem.name }} </h6> <h6> {{ (cacheItem.count_item) }}/{{ printMediasLength(cacheItem.items) }} </h6>
								</div>
							</div>
						</div>
						</div>
					</div>
				</template>
			</ModalFetchDisplayCache>
			<!-- modal confirmation delete macro -->
			<modal
				size="small"
				@close="isConfirmRemoveVisibleMacro = false"
				v-if="isConfirmRemoveVisibleMacro">
				<template slot="header">
					{{ $t('Remove Macro') }}
				</template>
				<template slot="body">
					{{ $t('Are you sure want to delete') }} {{ macroName }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="deleteMacro">
							{{ $t('Remove') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisibleMacro = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- modal limit api access -->
			<modal
				size="small"
				@close="isLimitApiAccess = false"
				v-if="isLimitApiAccess">
				<template slot="header">
					{{ $t('API ACCESS') }}
				</template>
				<template slot="body">
					{{ $t('The limit for accessing the API is 20 times left') }}
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							@click="isLimitApiAccess = false">
							{{ $t('OK') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- Confirm Render -->
			<modal
				size="small"
				@close="isModalConfirmRender = false"
				v-if="isModalConfirmRender">
				<template slot="header">
					<div class="truncate-media-property-name">{{ $t('Render') }} {{rundown && rundown.name ? rundown.name : ''}}</div>
				</template>
				<template slot="body">
					T<span class="lowercase">he output view and Render canvas are in different size, proceed to render?</span>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary mh-32" @click="renderRundown">
							{{ $t('OK') }}
						</button>
						<button
							@click="isModalConfirmRender = false"
							class="btn btn-default mh-32">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- modal stop all desktop -->
			<modal
				size="small"
				@close="showModalConfirmStopAllDesktop = false"
				v-if="showModalConfirmStopAllDesktop">
				<template slot="header">
					{{ $t('Confirm Stop All Rundown') }}
				</template>
				<template slot="body">
					<span class="tf-none pr-1">{{ $t('Stop all rundown, both PREVIEW and LIVE will be stopped') }}</span>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button class="btn btn-default" @click="showModalConfirmStopAllDesktop = false">
							{{ $t('Cancel') }}
						</button>
						<button class="btn btn-primary" :class="{ 'is-loading': isStopping }" @click="stopAll">
							{{ $t('Yes, Proceed') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- modal misc file -->
			<modal-misc :isShowMisc="isShowMisc" @close="closeMisc" :rundownId="rundownId" :rundown="rundown">

			</modal-misc>
		</div>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import ClickOutside from 'vue-click-outside';
import { mapActions, mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import XLSX from 'xlsx';
import EarthIcon from 'vue-material-design-icons/Earth.vue';
import ImageIcon from 'vue-material-design-icons/Image.vue';
import AlphaAIcon from 'vue-material-design-icons/AlphaA.vue';
import VideoIcon from 'vue-material-design-icons/Video.vue';
import ClockIcon from 'vue-material-design-icons/Clock.vue';
import TransitionIcon from 'vue-material-design-icons/Transition.vue';
import FormatTextRotationNoneIcon from 'vue-material-design-icons/FormatTextRotationNone.vue';
import RayStartEndIcon from 'vue-material-design-icons/RayStartEnd.vue';
// import WebcamIcon from 'vue-material-design-icons/Webcam.vue';
import CubeIcon from 'vue-material-design-icons/Cube.vue';
import MusicIcon from 'vue-material-design-icons/Music.vue';
// import fastSort from 'fast-sort';
import ViewCompactIcon from 'vue-material-design-icons/ViewCompact.vue';
import localforage from 'localforage';
import {
	getAxiosErrorMessage,
	duplicateVar,
	randomString,
	getVideoBlob,
	getJSON,
	elpisisString,
	csvInjection,
	copyToClipboard,
} from '@/lib/helper';
import {
	timerTemplate,
	itemTypes,
	lowerThirdDummyData,
	ColorDummyData,
	customPageDummyData,
	timerDummyData,
	tickerDummyData,
} from '@/lib/statics';
import rundownsApi from '@/api/rundowns';
import rundownItemsApi from '@/api/rundownItems';
import templatesApi from '@/api/templates';

import macrosApi from '@/api/macros';
import macrosItemsApi from '@/api/macro-items';
import MacroButton from '@/components/MacroButton.vue';
import Modal from '@/components/Modal.vue';
import ModalBottomSheet from '@/components/ModalBottomSheet.vue';
import ModalTakeOver from '@/components/ModalRundownTakeOver.vue';

import LowerThirdProperty from '@/components/LowerThirdProperty.vue';
import LowerThirdPropertyMobile from '@/components/LowerThirdPropertyMobile.vue';
import ZoomProperty from '@/components/ZoomProperty.vue';
import TimerProperty from '@/components/TimerProperty.vue';
import TickerProperty from '@/components/TickerProperty.vue';
import CustomPageProperty from '@/components/CustomPageProperty.vue';
import SeparatorProperty from '@/components/SeparatorProperty.vue';

import VideoInputProperty from '@/components/VideoInputProperty.vue';
import LottieProperty from '@/components/LottieProperty.vue';
import MediaProperty from '@/components/MediaProperty.vue';
import CompositionProperty from '@/components/CompositionProperty.vue';
import VirtualCamProperty from '@/components/VirtualCamProperty.vue';
import CustomCommandProperty from '@/components/CustomCommandProperty.vue';
import AudioProperty from '@/components/AudioProperty.vue';
import RtmpProperty from '@/components/RtmpProperty.vue';
import GalleryPopup from '@/components/GalleryPopup.vue';
import TemplatePopup from '@/components/TemplatePopup.vue';

import RundownItem from '@/components/RundownItem.vue';
import MacroModal from '@/components/MacroModal.vue';
import BlankProperty from '@/components/BlankProperty.vue';
import ModalImportLowerThird from '@/components/ModalImportNameLowerthird.vue';
import ModalFetchDisplayCache from '@/components/ModalFetchDisplayCache.vue';

import ModalMisc from '@/components/ModalMisc.vue';

// settings_ethernet
export default {
	name: 'RundownEditor',
	props: {
		slug: {
			type: String,
		},
	},
	components: {
		draggable,
		Modal,
		ModalBottomSheet,
		MediaProperty,
		TemplatePopup,
		GalleryPopup,
		RundownItem,
		LowerThirdProperty,
		LowerThirdPropertyMobile,
		CompositionProperty,
		ZoomProperty,
		TimerProperty,
		TickerProperty,
		CustomPageProperty,
		VideoInputProperty,
		LottieProperty,
		MacroModal,
		BlankProperty,
		EarthIcon,
		ImageIcon,
		AlphaAIcon,
		// WebcamIcon,
		// RadioTowerIcon,
		VideoIcon,
		ClockIcon,
		TransitionIcon,
		ViewCompactIcon,
		FormatTextRotationNoneIcon,
		RayStartEndIcon,
		CubeIcon,
		MusicIcon,
		SeparatorProperty,
		Loading,
		ModalTakeOver,
		ModalImportLowerThird,
		ModalFetchDisplayCache,
		VirtualCamProperty,
		CustomCommandProperty,
		MacroButton,
		AudioProperty,
		RtmpProperty,
		ModalMisc,
	},
	data() {
		return {
			rundown: null,
			items: [],
			itemsNotSeparator: [],
			keyword: '',
			filterType: 'all',
			filterShy: false,
			selectedItem: null,
			media: null,
			template: null,
			galleryTab: 'event', // event, all
			templateTab: 'all',
			rundownName: '',
			dragOptions: {
				animation: 50,
			},
			drag: false,
			isMediaFormVisible: false,
			isGalleryVisible: false,
			isTemplateVisible: false,
			isLowerThirdFormVisible: false,
			isLowerThirdFormMobileVisible: false,
			isConfirmDeleteVisible: false,
			isConfirmDeleteMobileVisible: false,
			isDeleting: false,
			isRenameVisible: false,
			isSavingRundown: false,
			isExporting: false,
			isImporting: false,
			isStopping: false,
			isCompositionFormVisible: false,
			isZoomFormVisible: false,
			isVideoInputFormVisible: false,
			isCustomPageFormVisible: false,
			isTickerFormVisible: false,
			isTimerFormVisible: false,
			isLottieFormVisible: false,
			isSeperatorVisible: false,
			isVirtualCamVisible: false,
			isCustomCommandVisible: false,
			isAudioVisible: false,
			isRtmpVisible: false,
			isShowTakeOver: false,
			isMacroVisible: false,
			isFetchingItems: false,
			isFetchingMacros: false,
			isAddingMacro: false,
			isHoverOnTheList: false,
			isMacrosListVisible: false,
			isFocusOnSearch: false,
			isBlankProperty: true,
			isScrollItem: false,
			isDisableItem: false,
			itemTypes: duplicateVar(itemTypes),
			lowerThirdDummyData: duplicateVar(lowerThirdDummyData),
			ColorDummyData: duplicateVar(ColorDummyData),
			customPageDummyData: duplicateVar(customPageDummyData),
			timerDummyData: duplicateVar(timerDummyData),
			tickerDummyData: duplicateVar(tickerDummyData),
			macros: [],
			macrosById: [],
			selectedMacro: null,
			showIframe: false,
			mainWidth: 870,
			selectedContextMacro: null,
			opened: false,
			macroId: null,
			addOpened: false,
			settingsOpened: false,
			filterOpened: false,
			stopAllOpened: false,
			scrolled: null,
			templates: [],
			templatesTicker: [],
			showBackgroundColor: false,
			showRender: false,
			isConfirmClearAll: false,
			isDeletingAllRundown: false,
			isClickItem: false,
			rundownItems: [],
			// loader
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			showLoadingScreen: true,
			cachingText: 'Hovering ',
			totalCached: 0,
			isShowImportLowerThird: false,
			cancelRequest: null,
			cancelRequestArray: [],
			cancelActive: false,
			displayCacheList: [],
			isShowDisplayCache: false,
			cacheDisplayCount: 0,
			itemAfterPrevious: null,
			itemBeforenext: null,
			isPlayingMacroListDone: true,
			minusIndexParent: 1,
			plusIndexParent: 1,
			macroActiveId: null,
			isConfirmRemoveVisibleMacro: false,
			macroName: '',
			isRemoving: false,
			// virtual cam
			virtualCam: null,
			virtualCams: [],
			virtualCamEdit: null,
			virtualCamsData: [],
			smallScreen: false,
			showModalConfirmStopAll: false,
			showModalConfirmStopAllDesktop: false,
			showAssets: true,
			isFetchingRundown: false,
			tempDelay: 500,
			closeContextItem: true,
			isUpdatingMacro: false,
			macroPlaying: 'idle',
			playMacroFromUrl: 0,
			isChangingBg: false,
			// popup notif limit
			isLimitApiAccess: false,
			// calcWidth
			calcWidth: 0,
			display: null,
			// render confirm
			typeRundown: '',
			isModalConfirmRender: false,
			addingItem: false,
			isSaving: false,
			itemsWithGroupId: [],
			positionItemDirection: '',
			idItemAfterDrag: null,
			// misc
			isShowMisc: false,
		};
	},
	sockets: {
		rundown_delete(id) {
			if (id) this.checkIfRundownDeleted(id);
		},
		rundown_stop(items) {
			this.onStopAll(items);
		},
		rundown_live_stop(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.updateItem(item);
			}
		},
		rundown_preview_stop(items) {
			this.onStopAllPreview(items);
		},
		item_insert(item) {
			this.insertItem(item);
		},
		item_update(item) {
			this.updateItem(item);
		},
		item_delete(id) {
			if (id) {
				this.removeItem(parseInt(id));
				this.fetchMacros(); // for update macroItems inside macro (optimize in the future)
				this.fetchItemsNotSeparator(); // for update macroItems inside macro (optimize in the future)
			}
		},
		items_live_update(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.updateItem(item);
			}
		},
		item_live_update(item) {
			if (item) {
				this.updateItem(item);
			}
		},
		access_force_play_item(item) {
			if (item) {
				this.updateItem(item);
			}
		},
		item_edit_preview(item) {
			this.updateSelectedItem(item);
		},
		item_preview_update(item) {
			this.updatePreview(item);
			// this.insertItem(item);
		},
		items_preview_update(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.updatePreview(item);
			}
		},
		item_bulk_delete(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.removeItem(item);
			}
			this.fetchMacros(); // for update macroItems inside macro (optimize in the future)
			this.fetchItemsNotSeparator(); // for update macroItems inside macro (optimize in the future)
		},
		rundown_update(payload) {
			this.rundown = payload;
			this.rundownName = payload.name;
		},
		reconnecting() {
			this.$notify({
				group: 'app',
				type: 'disconnect',
				title: 'connections disconnected ',
				text: 'Connection to server is disconnected, trying to reconnect',
			});
		},
		reconnect() {
			this.joinSocket();
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Update connections reconnected',
				text: 'Connection to server has been restored',
			});
		},
		update_storage(rundown) {
			this.rundown = rundown;
		},
		notify_item_cache(data) {
			const itemName = data.name || 'No Name';
			this.$notify({
				group: 'app',
				type: 'success',
				duration: 6000,
				closeOnClick: true,
				title: 'Update connections reconnected',
				text: `Your item : ${itemName} has been re-cached on display`,
			});
		},
		notify_cache_display(data) {
			this.isShowDisplayCache = true;
			this.insertDisplays(data);
		},
		disconnected() {
		},
		deleted_collaborator(collaborator) {
			const rundownIds = JSON.parse(collaborator.rundown_ids);
			if (rundownIds && rundownIds.length > 0) {
				if (rundownIds.includes(this.rundown.id)) {
					if (collaborator.user_id === this.user.id) {
						this.$router.push('/');
					}
				}
			}
		},
		items_reorder(data) {
			// const userId = data.user_id;
			const items = data.items;
			this.items = items;
		},
		item_show_playing(rundownItem) {
			this.insertItem(rundownItem, false);
		},
		excute_macro(payload) {
			const index = this.macros.findIndex(({ id }) => id === parseInt(payload));
			this.playMacro(this.macros[index]);
		},
		api_access(payload) {
			if (payload.status === 422) this.isLimitApiAccess = true;
		},
		rundown_display_update() {
			this.fetch(false);
		},
	},
	directives: {
		ClickOutside,
	},
	methods: {
		...mapActions({
			setNavbarVisible: 'setNavbarVisible',
			setDrawerVisible: 'setDrawerVisible',
		}),

		openMisc() {
			this.isShowMisc = true;
		},

		closeMisc() {
			this.isShowMisc = false;
		},

		changeDragAndDrop(state) {
			const movedData = state && state.moved ? state.moved : null;
			this.editItem(movedData.element);
			// this is usefull for detect if marker closed dragging to top or bottom, because
			// on each user drag item it, the system must add an index and place it according to the number of assets hidden in the marker
			this.idItemAfterDrag = null;
			this.positionItemDirection = '';
			if (movedData.element && movedData.element.type === 'separator' && movedData.newIndex > movedData.oldIndex) {
				this.positionItemDirection = 'bottom';
				this.idItemAfterDrag = movedData.element && movedData.element.id ? movedData.element.id : null;
			} else if (movedData.element && movedData.element.type === 'separator' && movedData.newIndex < movedData.oldIndex) {
				this.positionItemDirection = 'top';
				this.idItemAfterDrag = movedData.element && movedData.element.id ? movedData.element.id : null;
			}
		},
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		onCancel() {
			if (this.cancelRequest) {
				this.cancelRequest();
				for (let index = 0; index < this.cancelRequestArray.length; index++) {
					const cancelRequest = this.cancelRequestArray[index];
					cancelRequest();
				}
				this.cancelActive = true;
				this.initScreen();
			}
		},
		onImportLowerThirdComplete(items) {
			this.insertItems(items);
		},
		closeModalLowerThird() {
			this.isShowImportLowerThird = false;
		},
		closeTakeOver() {
			this.isShowTakeOver = false;
		},
		changeBackground(color) {
			this.isChangingBg = true;
			const params = {
				background_color: color,
			};
			const callback = () => {
				this.showBackgroundColor = false;
				this.isChangingBg = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Rundown',
					text: message,
				});
				this.isChangingBg = false;
			};
			rundownsApi.changeBackground(this.rundownId, params, callback, errorCallback);
		},
		confirmRender(type) {
			this.settingsOpened = false;
			this.typeRundown = type;
			// check if output and render size are different
			const renderSize = localStorage.getItem(`default_render_size_${this.user.id}`) ? JSON.parse(localStorage.getItem(`default_render_size_${this.user.id}`)) : null;
			const outputSize = localStorage.getItem(`default_output_size_${this.user.id}`) ? JSON.parse(localStorage.getItem(`default_output_size_${this.user.id}`)) : null;
			const renderSizeWidth = renderSize && renderSize.displaySize && renderSize.displaySize.width ? renderSize.displaySize.width : 1920;
			const renderSizeHeight = renderSize && renderSize.displaySize && renderSize.displaySize.height ? renderSize.displaySize.height : 1080;
			const outputSizeWidth = outputSize && outputSize.width ? outputSize.width : 1920;
			const outputSizeHeight = outputSize && outputSize.height ? outputSize.height : 1080;
			// start checking, show warn if output and render are different
			if (parseInt(renderSizeWidth) === parseInt(outputSizeWidth) && parseInt(renderSizeHeight) === parseInt(outputSizeHeight)) {
				this.renderRundown();
			} else {
				this.isModalConfirmRender = true;
				this.showRender = false;
			}
		},
		renderRundown() {
			this.isModalConfirmRender = false;
			const defaultOutputSize = localStorage.getItem(`default_render_size_${this.user.id}`);
			const parsedDefaultOutputSize = defaultOutputSize && typeof (defaultOutputSize) === 'string' ? JSON.parse(defaultOutputSize) : null;
			const width = parsedDefaultOutputSize && parsedDefaultOutputSize.displaySize ? parseInt(parsedDefaultOutputSize.displaySize.width) : 1920;
			const height = parsedDefaultOutputSize && parsedDefaultOutputSize.displaySize ? parseInt(parsedDefaultOutputSize.displaySize.height) : 1080;
			const callback = (response) => {
				this.showRender = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update Rundown',
					text: response.message,
				});
				this.typeRundown = '';
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Rundown',
					text: message,
				});
				this.showRender = false;
				this.isModalConfirmRender = false;
				this.typeRundown = '';
			};
			const params = {
				id: this.rundownId,
				type: this.typeRundown,
				canvas_width: width,
				canvas_height: height,
				background_color: this.typeRundown === 'video' || this.typeRundown === 'merged_video' ? 'white' : 'transparent',
			};
			rundownsApi.renderRundown(params, callback, errorCallback);
		},
		toggleContextAdd() {
			this.addOpened = !this.addOpened;
		},
		hideContextAdd() {
			this.addOpened = false;
		},
		toggleContextStopAll() {
			this.stopAllOpened = !this.stopAllOpened;
		},
		toggleContextSettings() {
			this.settingsOpened = !this.settingsOpened;
		},
		hideContextSettings() {
			this.settingsOpened = false;
		},
		toggleContextFilter() {
			this.filterOpened = !this.filterOpened;
		},
		hideContextFilter() {
			this.filterOpened = false;
		},
		hideContextStopAll() {
			this.stopAllOpened = false;
		},
		contextMacro(macro) {
			this.selectedContextMacro = macro;
		},
		showOnLoad() {
			this.showIframe = true;
		},
		updateRundown() {
			this.isSavingRundown = true;
			const name = this.rundownName.trim();
			const params = {
				name,
			};
			const callback = (response) => {
				const rundown = response.data;
				this.rundownName = rundown.name;
				this.isSavingRundown = false;
				this.isRenameVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Rundown',
					text: message,
				});
				this.isSavingRundown = false;
			};
			rundownsApi.update(this.rundownId, params, callback, errorCallback);
		},
		checkIfRundownDeleted(id) {
			if (this.rundown && parseInt(this.rundown.id) === parseInt(id)) this.redirectIfNoRundown();
		},
		redirectIfNoRundown() {
			this.$notify({
				group: 'app',
				type: 'error',
				title: 'Rundown',
				text: 'Rundown not available',
			});
			this.$router.push('/').catch(() => {});
		},
		fetch(isRefetchRundown = true) {
			this.isFetchingRundown = true;
			const callback = (response) => {
				const rundown = response.data;
				if (!rundown) this.redirectIfNoRundown();
				this.rundown = rundown;
				if (this.currentActiveUsers && this.currentActiveUsers !== -1) {
					this.isShowTakeOver = false;
				}
				if (this.rundown.background_color === 'transparent') this.changeBackground('#FFFFFF');
				if (isRefetchRundown) this.fetchItems(true, true); // always reset and remove all local storage
				if (this.rundown && this.rundown.defaultRender) localStorage.setItem(`default_render_size_${this.user.id}`, JSON.stringify(this.rundown.defaultRender));
				// set default output size on localstorage
				const displayOutputDefault = this.rundown && this.rundown.display && this.rundown.display.displaySize ? this.rundown.display.displaySize : null;
				localStorage.setItem(`default_output_size_${this.user.id}`, JSON.stringify(displayOutputDefault));
				this.isFetchingRundown = false;
			};
			const errorCallback = (e) => {
				console.log(e);
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
				if (message === 'You dont have access to this rundown') this.$router.push('/rundowns').catch(() => {});
				this.isFetchingRundown = false;
			};
			rundownsApi.getBySlug(atob(this.slug), callback, errorCallback);
		},
		cacheDisplays() {
			const callback = () => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Media Saved',
					text: 'Rebuilding cache for Displays',
				});
			};
			const callbackError = () => {
			};
			const params = {
				display_name: '',
			};
			rundownsApi.cacheDisplay(this.rundown.id, params, callback, callbackError);
		},
		// exampleChekAxios() {
		// 	axios.get('http://127.0.0.1:3333/file/application/1604989721975-1603615426462-xclean-corporate-01-01.json')
		// 		.then((res) => {
		// 		});
		// },
		rebuildCache() {
			this.cacheDisplays();
			this.showLoadingScreen = true;
			this.totalCached = 0;
			const medias = this.items.filter(item => ((item.type === 'image' || item.type === 'video' || item.type === 'lottie' || item.type === 'lower_third')));
			for (let index = 0; index < medias.length; index++) {
				const item = medias[index];

				let content = item.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}

				let videoKey = '';
				if ((item.type === 'image' || item.type === 'video') && content && content.id) videoKey = `media_${content.id}`;
				if (item.type === 'lottie' && content && content.id) videoKey = `lottie_media_${content.id}`;
				if (item.type === 'lower_third' && content && content.template && content.template.id) videoKey = `lottie_lt_${content.template.id}`;
				localforage.removeItem(videoKey, (err) => {
					if (!err) {
						// this.isCached = false;
						this.$notify({
							group: 'app',
							type: 'success',
							title: 'Media Saved',
							text: `Rebuilding cache for ${item.name}`,
						});
						// const videoSource = URL.createObjectURL(blob);
						// this.videoSource = videoSource;
						// this.isVideoDownloaded = true;
						// this.isDownloading = false;
					}
				});
			}
			this.fetchItems();
		},
		fetchItems(reset = true, isRemoveLocalDuration = false) {
			this.isFetchingItems = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			const rundownId = this.rundown.id;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'order',
				sort_by: 'asc',
				rundown_id: rundownId,
			};
			const type = this.filterType;
			const keyword = this.keyword.trim();
			if (type !== 'all') params.type = type;
			if (keyword !== '') params.keyword = keyword;
			const callback = (response) => {
				const items = response.data;
				this.items = items;
				this.isFetchingItems = false;
				this.cancelActive = false;
				// disable caching if small screen/mobile device, because PREVIEW and LIVE screen is not required
				if (isRemoveLocalDuration) {
					for (let index = 0; index < this.filteredItems.length; index++) {
						const item = this.filteredItems[index];
						localStorage.removeItem(`item_duration_${item.id}`);
					}
				}
				if (!this.smallScreen) this.startCache();
				this.isFetchingRundown = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown Assets',
					text: message,
				});
				this.isFetchingRundown = false;
			};
			rundownItemsApi.getList(params, callback, errorCallback);
		},
		initScreen() {
			this.showLoadingScreen = false;
		},
		startCache() {
			const medias = this.items.filter(item => ((item.type === 'image' || item.type === 'video' || item.type === 'lower_third' || item.type === 'lottie')));
			// If no media (image or video)
			if (medias.length === 0) this.initScreen();
			// Cache
			this.cachingText = `Bottling assets 0/${medias.length}`;
			for (let index = 0; index < medias.length; index++) {
				if (this.cancelActive) return;
				this.cachingText = `Bottling assets ${this.totalCached}/${medias.length}`;
				const item = medias[index];
				const totalMedia = medias.length;

				let itemKey = `media_${item.id}`;
				let content = item.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}

				if ((item.type === 'image' || item.type === 'video') && content && content.id) itemKey = `media_${content.id}`;
				if (item.type === 'lottie' && content && content.id) itemKey = `lottie_media_${content.id}`;
				if (item.type === 'lower_third' && content && content.template && content.template.id) itemKey = `lottie_lt_${content.template.id}`;

				// eslint-disable-next-line no-loop-func
				localforage.getItem(itemKey, (err, value) => {
					if (!err && value) {
						this.totalCached += 1;
					} else {
						const mediaKey = itemKey;
						const mediaContent = item && item.content ? JSON.parse(item.content) : null;
						const itemMediaPath = mediaContent && mediaContent.url ? mediaContent.url : null;
						const itemMediaName = mediaContent && mediaContent.label ? mediaContent.label : null;
						const url = mediaContent && mediaContent.template && mediaContent.template.file_path ? mediaContent.template.file_path : null;
						if (itemMediaPath && (item.type === 'image' || item.type === 'video')) {
							this.cacheFile(mediaKey, itemMediaPath, itemMediaName, index, totalMedia);
						} else if (itemMediaPath && item.type === 'lottie') {
							this.cacheLowerThird(itemKey, itemMediaPath, itemMediaName, index, totalMedia);
						} else if (url && item.type === 'lower_third') {
							this.cacheLowerThird(itemKey, url, itemMediaName, index, totalMedia);
						} else {
							this.totalCached += 1;
						}
					}
					if (this.totalCached >= totalMedia) {
						this.initScreen();
						this.totalCached = 0;
					}
				});
			}
		},
		cacheLowerThird(lottieKey, url, itemMediaName, index, total) {
			try {
				let data = null;
				localforage.getItem(lottieKey).then(async (value) => {
					if (value) {
						data = value;
					} else {
						const cancelCallback = (c) => {
							this.cancelRequest = c;
							this.cancelRequestArray.push(c);
						};
						getJSON(url, cancelCallback).then((response) => {
							// Check videoBlob
							if (this.cancelActive) return;
							if (!response) return;
							data = response;
							const localData = duplicateVar(data);
							localforage.setItem(lottieKey, localData).then(() => localforage.getItem(lottieKey)).then((value) => {
								if (this.cancelActive) return;
								if (value) {
									this.$notify({
										group: 'app',
										type: 'success',
										title: 'Media Saved',
										text: 'Media is cached',
									});
									// eslint-disable-next-line no-param-reassign
									// total -= 1;
									this.totalCached += 1;
									this.cachingText = `Bottling assets ${this.totalCached}/${total}`;
								}
								if (this.totalCached >= total) {
									this.initScreen();
									this.totalCached = 0;
								}
							}).catch((err) => {
								// we got an error
								if (err) {
									this.totalCached += 1;
									if (this.totalCached >= total) {
										this.initScreen();
										this.totalCached = 0;
									}
									this.$notify({
										duration: 6000,
										closeOnClick: true,
										group: 'app',
										type: 'error',
										title: 'Error loading media',
										text: 'Something went wrong please contact admin!',
									});
								}
							});
						}).catch(() => {
							this.totalCached += 1;
							if (this.totalCached >= total) {
								this.initScreen();
								this.totalCached = 0;
							}
							// error handling logic
							const message = `Lower Third: ${itemMediaName}. Sorry, some file can't be loaded or not found, please check`;
							this.$notify({
								duration: 6000,
								closeOnClick: true,
								group: 'app',
								type: 'error',
								title: 'Error loading media',
								text: message,
							});
						});
					}
					// this.updatelottiedata(data);
					// this.parseLottieData(data, isReset);
				});
			} catch (err) {
				this.totalCached += 1;
				if (this.totalCached >= total) {
					this.initScreen();
					this.totalCached = 0;
				}
			}
		},
		cacheFile(mediaKey, itemMediaPath, itemMediaName, index, total) {
			// get media assets as blob....
			try {
				const cancelCallback = (c) => {
					this.cancelRequest = c;
					this.cancelRequestArray.push(c);
				};
				getVideoBlob(itemMediaPath, cancelCallback).then((blob) => {
					// Check videoBlob
					if (this.cancelActive) return;
					if (!blob) return;
					// Set key and blob
					localforage.setItem(mediaKey, blob, (err, value) => {
						if (!err && value) {
							this.$notify({
								group: 'app',
								type: 'success',
								title: 'Media Saved',
								text: 'Media is cached',
							});
							// eslint-disable-next-line no-param-reassign
							// total -= 1;
							this.totalCached += 1;
							this.cachingText = `Bottling assets ${this.totalCached}/${total}`;
						}
						if (this.totalCached >= total) {
							this.initScreen();
							this.totalCached = 0;
						}
						if (err) {
							this.totalCached += 1;
							if (this.totalCached >= total) {
								this.initScreen();
								this.totalCached = 0;
							}
							this.$notify({
								duration: 6000,
								closeOnClick: true,
								group: 'app',
								type: 'error',
								title: 'Error loading media',
								text: 'Something went wrong please contact admin!',
							});
						}
					});
				}).catch(() => {
					this.totalCached += 1;
					if (this.totalCached >= total) {
						this.initScreen();
						this.totalCached = 0;
					}
					// error handling logic
					const message = `Media: ${itemMediaName}. Sorry, some media file can't be loaded or media not found, please check`;
					this.$notify({
						duration: 6000,
						closeOnClick: true,
						group: 'app',
						type: 'error',
						title: 'Error loading media',
						text: message,
					});
				});
			} catch (err) {
				this.totalCached += 1;
				if (this.totalCached >= total) {
					this.initScreen();
					this.totalCached = 0;
				}
			}
		},
		fetchItemsNotSeparator(keyword) {
			this.isFetchingItems = true;
			const rundownId = this.rundown.id;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'order',
				sort_by: 'asc',
				rundown_id: rundownId,
				not_type: 'separator',
			};
			if (keyword !== '') params.keyword = keyword;
			const callback = (response) => {
				const items = response.data;
				this.itemsNotSeparator = items;
				this.isFetchingItems = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown Assets',
					text: message,
				});
				this.isFetchingItems = false;
			};
			rundownItemsApi.getList(params, callback, errorCallback);
		},
		initData() {
			if (atob(this.slug)) this.fetch();
		},
		filter(type) {
			this.filterType = type;
			// this.fetchItems(true);
		},
		closeAllProperties() {
			// this.selectedItem = null;
			this.media = null;
			this.isLowerThirdFormVisible = false;
			this.isLowerThirdFormMobileVisible = false;
			this.isMediaFormVisible = false;
			this.isCompositionFormVisible = false;
			this.isCustomPageFormVisible = false;
			this.isTimerFormVisible = false;
			this.isTickerFormVisible = false;
			this.isZoomFormVisible = false;
			this.isVideoInputFormVisible = false;
			this.isCompositionFormVisible = false;
			this.isLottieFormVisible = false;
			this.isSeperatorVisible = false;
			this.isVirtualCamVisible = false;
			this.isCustomCommandVisible = false;
			this.isAudioVisible = false;
			this.isRtmpVisible = false;
			this.isBlankProperty = true;
		},
		addItem(type = 'lower_third') {
			this.closeAllProperties();
			// this.selectedItem = null;
			if (type === 'lower_third') {
				this.addingItem = true;
				this.fetchTemplates();
			} else {
				this.addingItem = true;
				this.itemTypeVisible(type, true);
			}
		},
		fetchTemplates() {
			const callback = (response) => {
				const templates = response.data;
				this.templates = templates;
				this.itemTypeVisible('lower_third', true);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Templates',
					text: message,
				});
				this.addingItem = false;
			};
			templatesApi.getRandom(callback, errorCallback);
		},
		fetchTemplatesTicker() {
			const params = {
				page: 1,
				limit: 10,
				order_by: 'name',
				sort_by: 'asc',
				type: 'ticker',
			};
			const callback = (response) => {
				const templates = response.data;
				this.templatesTicker = templates;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Templates',
					text: message,
				});
			};
			templatesApi.getList(params, callback, errorCallback);
		},
		inserAt(pos, ele, arr) {
			let n = arr.length;
			n++; //  increase the length of orignal array
			for (let i = n - 1; i >= pos; i--) { // start shifting the last element to the next index and so on till the position
				// eslint-disable-next-line no-param-reassign
				arr[i] = arr[i - 1];
			}
			// eslint-disable-next-line no-param-reassign
			arr[pos - -1] = ele; // store the element
		},
		async saveItem(type) {
			this.isSaving = true;
			const selectedItemId = this.selectedItem && this.selectedItem.id ? this.selectedItem.id : null;
			const order = this.items.findIndex(({ id }) => id === selectedItemId);
			let orderSelectedItem = order !== -1 ? order + 1 : null;
			// if selected is on closed marker and closed marker has more than one assets
			const markerClosed = this.items.find(({ id, type }) => id === selectedItemId && type === 'separator');
			if (markerClosed) {
				const listGroupMarker = this.items.filter(item => item.group_id === markerClosed.group_id);
				// eslint-disable-next-line
				if (listGroupMarker.length > 1) orderSelectedItem = orderSelectedItem + (listGroupMarker.length - 1);
			}
			// start save item
			const callback = (response) => {
				const item = response.data;
				this.selectedItem = null;
				this.selectedItem = item;
				this.$nextTick().then(() => {
					if (type === 'lower_third') {
						this.isLowerThirdFormVisible = true;
						this.isLowerThirdFormMobileVisible = true;
					} else if (type === 'image' || type === 'media' || type === 'video') {
						this.isMediaFormVisible = true;
					} else if (type === 'composition') {
						this.isCompositionFormVisible = true;
					} else if (type === 'custom_page') {
						this.isCustomPageFormVisible = true;
					} else if (type === 'timer') {
						this.isTimerFormVisible = true;
					} else if (type === 'ticker') {
						this.isTickerFormVisible = true;
					} else if (type === 'zoom_meeting') {
						this.isZoomFormVisible = true;
					} else if (type === 'video_input') {
						this.isVideoInputFormVisible = true;
					} else if (type === 'lottie') {
						this.isLottieFormVisible = true;
					} else if (type === 'separator') {
						this.isSeperatorVisible = true;
					} else if (type === 'virtual_cam') {
						this.isVirtualCamVisible = true;
					} else if (type === 'custom_command') {
						this.isCustomCommandVisible = true;
					} else if (type === 'audio') {
						this.isAudioVisible = true;
					} else if (type === 'lightstream_rtmp') {
						this.isRtmpVisible = true;
					}
				});
				// }, 100);
				this.isBlankProperty = false;
				this.isSaving = false;
				this.addingItem = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Item',
					text: message,
				});
				this.isSaving = false;
				this.addingItem = false;
			};
			let typeName = '';
			let defaultIndex = 0;
			let params = '';
			// init canvas size
			const outputSize = localStorage.getItem(`default_output_size_${this.user.id}`) ? JSON.parse(localStorage.getItem(`default_output_size_${this.user.id}`)) : null;
			const outputSizeWidth = outputSize && outputSize.width ? outputSize.width : 1920;
			const outputSizeHeight = outputSize && outputSize.height ? outputSize.height : 1080;
			const ratioOriginal = Math.min(outputSizeWidth / 1920, outputSizeHeight / 1080);
			const heightDisplay = parseInt(outputSizeHeight);
			const widthDisplay = parseInt(outputSizeWidth);
			// init Content
			if (this.userSettings && this.userSettings.is_enable_dummy_item_data) {
				const content = {
					url: '',
					label: '',
					width: 1920,
					height: 1080,
					duration: '00:00:05',
					timer: 0,
					position: 'default',
					x: 0,
					y: 0,
					isRatio: true,
					isPosition: false,
					fontStyle: 0,
					opacity: 100,
					childOrder: 0,
				};
				if (type === 'ticker') content.fontStyle = 14;
				if (type === 'audio') content.fontStyle = 14;
				if (type === 'lower_third') {
					typeName = 'LOWER THIRD';
					// randomize template to select the currently fitted templates
					const selectedTemplate = this.templates;
					// const selectedDummy = this.lowerThirdDummyData[Math.floor(Math.random() * this.lowerThirdDummyData.length)];
					content.template = selectedTemplate || this.templates;
					content.duration = '00:00:05';
					// content.h1 = selectedDummy.h1 || 'fikuri nugraha is default';
					// content.h2 = selectedDummy.h2 || 'fikuri nugraha is default';
					// content.h3 = selectedDummy.h3 || selectedDummy.h1;
					// content.h4 = selectedDummy.h4 || selectedDummy.h2;
					// content.h1_color = this.ColorDummyData.colorText1;
					// content.h2_color = this.ColorDummyData.colorText2;
					// content.h3_color = this.ColorDummyData.colorText3;
					// content.h4_color = this.ColorDummyData.colorText4;
					// content.color_1 = this.ColorDummyData.fillColor1;
					// content.color_2 = this.ColorDummyData.fillColor2;
					// content.color_3 = this.ColorDummyData.fillColor3;
					// content.color_4 = this.ColorDummyData.fillColor4;
					content.lottieSpeed = '1';
					content.lottieScale = 'default';
					content.isDefault = true;
					defaultIndex = 25;
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'image') {
					typeName = 'MEDIA - IMAGE';
					defaultIndex = 1;
				} else if (type === 'video') {
					typeName = 'MEDIA - VIDEO';
					defaultIndex = 2;
				} else if (type === 'composition') {
					typeName = 'COMPOSITION';
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'custom_page') {
					content.customPageUrl = this.customPageDummyData[0].url;
					typeName = 'BROWSER SOURCE';
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'timer') {
					// const filteredTemplates = this.templates.length !== 0 ? this.templates.filter(t => t.type === type) : [];
					content.timerSetting = 3;
					// randomize template to select the currently fitted templates
					// const selectedTemplate = filteredTemplates[Math.floor(Math.random() * filteredTemplates.length)];
					content.template = timerTemplate.find(({ id }) => id === content.timerSetting);
					content.message = this.timerDummyData[0].message;
					content.time = this.timerDummyData[0].duration;
					content.color = this.timerDummyData[0].color;
					content.backgroundColor = this.timerDummyData[0].bgColor;
					content.fontColor = '#FFFF';
					content.fontStyle = 7;
					typeName = 'TIMER';
					defaultIndex = 10;
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'ticker') {
					// randomize template to select the currently fitted templates
					const selectedTemplate = await this.filteredTickerTemplates(this.templatesTicker);
					content.template = selectedTemplate || null;

					content.tickerData = this.tickerDummyData[0].tickerData;
					// content.template= this.tickerDummyData[0].,
					content.speed = this.tickerDummyData[0].speed;
					content.fontColor = this.tickerDummyData[0].color;
					content.backgroundColor = this.tickerDummyData[0].bgColor;
					content.gradient = false;
					content.angle = 0;

					typeName = 'TICKER';
					defaultIndex = 20;
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width = widthDisplay;
						content.height = heightDisplay;
						// change position
						content.x = 0;
						content.y = 0;
					}
				} else if (type === 'zoom_meeting') {
					typeName = 'ZOOM MEETING ';
				} else if (type === 'video_input') {
					typeName = 'VIDEO INPUT ';
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'lottie') {
					typeName = 'LOTTIE ANIMATION ';
					defaultIndex = 15;
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'separator') {
					content.SeparatorFontColor = '#FFFFFFFF';
					content.SeparatorBGColor = '#FF0000FF';
					typeName = 'MARKER LABEL GOES HERE ';
				} else if (type === 'virtual_cam') {
					typeName = 'CUSTOM CAM';
				} else if (type === 'custom_command') {
					typeName = 'CUSTOM COMMAND';
				} else if (type === 'audio') {
					typeName = 'AUDIO';
					defaultIndex = 3;
				} else if (type === 'lightstream_rtmp') {
					typeName = 'Lightstream RTMP';
					defaultIndex = 2;
					content.rtmp_url = 'rtmp://ingest.golightstream.com/cloud/';
				}
				params = {
					type,
					content: JSON.stringify(content),
					status: 1,
					is_play_live: 0,
					is_play_preview: 0,
					rundown_id: this.rundown.id,
					name: `${typeName}-${randomString(6)}`,
				};
				if (defaultIndex) {
					params.layer_index = defaultIndex;
				} else {
					params.layer_index = 1;
				}
				if (type !== 'custom_command') {
					params.name = `${typeName}-${randomString(6)}`;
				} else {
					params.name = typeName;
				}
			} else {
				const content = {
					url: '',
					label: '',
					width: 1920,
					height: 1080,
					timer: 0,
					position: 'default',
					x: 0,
					y: 0,
					isRatio: true,
					isPosition: false,
					isParent: false,
					fontStyle: 0,
					opacity: 100,
					childOrder: 0,
				};
				if (type === 'lower_third') {
					content.duration = '00:00:05';
					content.lottieSpeed = '1';
					content.lottieScale = 'default';
					typeName = 'LOWER THIRD';
					defaultIndex = 25;
				} else if (type === 'image') {
					typeName = 'MEDIA - IMAGE';
					defaultIndex = 1;
				} else if (type === 'video') {
					typeName = 'MEDIA - VIDEO';
					defaultIndex = 2;
				} else if (type === 'composition') {
					typeName = 'COMPOSITION';
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'custom_page') {
					typeName = 'BROWSER SOURCE';
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'timer') {
					content.timerSetting = 3;
					content.time = this.timerDummyData[0].duration;
					content.color = this.timerDummyData[0].color;
					content.backgroundColor = this.timerDummyData[0].bgColor;
					content.message = '';
					content.fontColor = '#FFFF';
					content.fontStyle = 7;
					typeName = 'TIMER';
					defaultIndex = 10;
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'ticker') {
					const selectedTemplate = await this.filteredTickerTemplates(this.templatesTicker);
					content.template = selectedTemplate || null;
					content.tickerData = this.tickerDummyData[0].tickerData;
					content.speed = this.tickerDummyData[0].speed;
					content.fontColor = this.tickerDummyData[0].color;
					content.backgroundColor = this.tickerDummyData[0].bgColor;
					content.gradient = false;
					content.angle = 0;
					typeName = 'TICKER';
					defaultIndex = 20;
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width = widthDisplay;
						content.height = heightDisplay;
						// change position
						content.x = 0;
						content.y = 0;
					}
				} else if (type === 'zoom_meeting') {
					typeName = 'ZOOM MEETING ';
				} else if (type === 'video_input') {
					typeName = 'VIDEO INPUT ';
					// init size if canvas not on 16:9
					if ((widthDisplay !== 1920 && heightDisplay !== 1080) || (widthDisplay / heightDisplay !== 1.7777777777777777)) {
						content.width 	= ratioOriginal * 1920;
						content.height	= ratioOriginal * 1080;
						content.x = (outputSizeWidth - content.width) / 2;
						content.y = (outputSizeHeight - content.height) / 2;
					}
				} else if (type === 'lottie') {
					typeName = 'LOTTIE ANIMATION ';
					defaultIndex = 15;
				} else if (type === 'separator') {
					content.SeparatorFontColor = '#FFFFFFFF';
					content.SeparatorBGColor = '#FF0000FF';
					typeName = 'MARKER LABEL GOES HERE ';
				} else if (type === 'virtual_cam') {
					typeName = 'VIRTUAL CAM ';
				} else if (type === 'custom_command') {
					typeName = 'CUSTOM COMMAND ';
				} else if (type === 'audio') {
					typeName = 'AUDIO ';
					defaultIndex = 3;
				} else if (type === 'lightstream_rtmp') {
					typeName = 'Lightstream RTMP';
					defaultIndex = 2;
					content.rtmp_url = 'rtmp://ingest.golightstream.com/cloud/';
				}

				params = {
					type,
					content: JSON.stringify(content),
					status: 1,
					is_play_live: 0,
					is_play_preview: 0,
					rundown_id: this.rundown.id,
					name: `${typeName}-${randomString(6)}`,
				};
				if (defaultIndex) {
					params.layer_index = defaultIndex;
				} else {
					params.layer_index = 1;
				}
			}
			if (orderSelectedItem) {
				params.order = orderSelectedItem;
			} else {
				params.order = this.items.length + 1;
			}
			if (type === 'custom_command') params.layer_index = 110;
			rundownItemsApi.create(params, callback, errorCallback);
		},
		itemTypeVisible(type, isCreate = false) {
			this.closeAllProperties();
			this.template = null;
			if (isCreate) {
				this.saveItem(type);
			} else {
				// delay(() => {
				// this.save();
				this.$nextTick().then(() => {
					// this.renderComponent = true;
					if (type === 'lower_third') {
						this.isLowerThirdFormVisible = true;
					} else if (type === 'image' || type === 'media' || type === 'video') {
						this.isMediaFormVisible = true;
					} else if (type === 'composition') {
						this.isCompositionFormVisible = true;
					} else if (type === 'custom_page') {
						this.isCustomPageFormVisible = true;
					} else if (type === 'timer') {
						this.isTimerFormVisible = true;
					} else if (type === 'ticker') {
						this.isTickerFormVisible = true;
					} else if (type === 'zoom_meeting') {
						this.isZoomFormVisible = true;
					} else if (type === 'video_input') {
						this.isVideoInputFormVisible = true;
					} else if (type === 'lottie') {
						this.isLottieFormVisible = true;
					} else if (type === 'separator') {
						this.isSeperatorVisible = true;
					} else if (type === 'virtual_cam') {
						this.isVirtualCamVisible = true;
					} else if (type === 'custom_command') {
						this.isCustomCommandVisible = true;
					} else if (type === 'audio') {
						this.isAudioVisible = true;
					} else if (type === 'lightstream_rtmp') {
						this.isRtmpVisible = true;
					}
				});
				// }, 100);
				this.isBlankProperty = false;
				this.addingItem = false;
			}
		},
		addMedia() {
			this.closeAllProperties();
			this.selectedItem = null;
			this.isMediaFormVisible = true;
		},
		addLowerThird() {
			this.closeAllProperties();
			this.selectedItem = null;
			this.isLowerThirdFormVisible = true;
		},
		onAddItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			} else {
				// this.$set(this.items, index, item);
				// this.$set(this.itemsNotSeparator, index, item);
				// eslint-disable-next-line no-lonely-if
				if (item) {
					if (this.items[index]) Object.assign(this.items[index], item);
					if (this.itemsNotSeparator[index]) Object.assign(this.itemsNotSeparator[index], item);
				}
			}
			if (this.selectedItem && this.selectedItem.id === item.id) this.selectedItem = duplicateVar(item);
			this.media = null;
		},
		openGallery() {
			this.media = null;
			this.galleryTab = 'event';
			this.isGalleryVisible = true;
		},

		setTemplate(template) {
			this.template = template;
		},
		openTemplate() {
			// this.template = null;
			this.templateTab = 'all';
			this.isTemplateVisible = true;
		},
		onGallerySelected(media) {
			this.media = media;
			this.isGalleryVisible = false;
		},
		onTemplateSelected(template) {
			this.template = template;
			this.isTemplateVisible = false;
		},

		closeModalTemplate() {
			this.isTemplateVisible = false;
		},
		updateSelectedItem(item) {
			const tmpSelectedItem = duplicateVar(this.selectedItem);
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index !== -1) {
				this.$set(this.items, index, item);
				this.selectedItem = duplicateVar(item);
				if (tmpSelectedItem && tmpSelectedItem.id !== item.id) {
					this.itemTypeVisible(item.type);
				}
			}
		},
		updateItem(item) {
			const localItem = item;
			const index = this.items.findIndex(({ id }) => id === localItem.id);
			if (index !== -1) {
				if (this.selectedItem) {
					const itemId = localItem && localItem.id ? localItem.id : null;
					const selectedItemId = this.selectedItem && this.selectedItem.id ? this.selectedItem.id : null;
					const currentItem = itemId === selectedItemId ? duplicateVar(localItem) : duplicateVar(this.selectedItem);
					if (itemId === selectedItemId) Object.assign(this.selectedItem, currentItem);
					Object.assign(this.items, currentItem);
				}
			}
			const isArrayItem = Array.isArray(localItem);
			if (isArrayItem) this.insertItem(localItem[0], false);
			if (!isArrayItem) this.insertItem(localItem, false);
		},
		updatePreview(item) {
			const localItem = item;
			const isArrayItem = Array.isArray(localItem);
			const index = this.items.findIndex(({ id }) => id === localItem.id);

			if (index !== -1) {
				if (this.selectedItem) {
					const itemId = localItem && localItem.id ? localItem.id : null;
					const selectedItemId = this.selectedItem && this.selectedItem.id ? this.selectedItem.id : null;
					const currentContent = this.items[index] && this.items[index].content ? (this.items[index].content) : null;
					localItem.content = (currentContent);
					const currentItem = itemId === selectedItemId ? duplicateVar(localItem) : duplicateVar(this.selectedItem);
					Object.assign(this.items, currentItem);
				}
			}

			if (isArrayItem) {
				const currentContent = this.items[index] && this.items[index].content ? (this.items[index].content) : null;
				localItem[0].content = (currentContent);
				this.insertItem(localItem[0], false);
			}
			if (!isArrayItem) {
				const currentContent = this.items[index] && this.items[index].content ? (this.items[index].content) : null;
				localItem.content = (currentContent);
				this.insertItem(localItem, false);
			}
		},
		closeModalConfirmDelete() {
			this.isBlankProperty = false;
			this.isConfirmDeleteVisible = false;
			this.isConfirmDeleteMobileVisible = false;
			this.closeContextItem = true;
		},
		confirmDeleteItem(item) {
			this.closeContextItem = false;
			this.editItem(item);
			const isNotRemovable = this.selectedItem && (this.selectedItem.is_locked);
			if (isNotRemovable) return;

			if (this.smallScreen) {
				this.isConfirmDeleteMobileVisible = true;
			} else {
				this.isConfirmDeleteVisible = true;
			}
			if (this.items.length <= 1) {
				this.closeAllProperties();
				this.isBlankProperty = false;
			}
		},
		deleteLocalForage(item) {
			let content = item.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			let itemKey = '';
			if ((item.type === 'image' || item.type === 'video') && content && content.id) itemKey = `media_${content.id}`;
			if (item.type === 'lottie' && content && content.id) itemKey = `lottie_media_${content.id}`;
			if (item.type === 'lower_third' && content && content.template && content.template.id) itemKey = `lottie_lt_${content.template.id}`;
			localforage.getItem(itemKey).then(() => {
				localforage.removeItem(itemKey);
			});
			// remove separator on localstorage
			if (item.type === 'separator') {
				itemKey = `is_folder_visible_${item.id}`;
				localStorage.removeItem(itemKey);
			}
		},
		deleteItem(item) {
			this.selectedItem = item;
			const isNotRemovable = this.selectedItem && (this.selectedItem.is_locked);
			if (isNotRemovable) return;

			this.isDeleting = true;
			const id = item.id;
			const callback = () => {
				this.deleteLocalForage(item);
				this.isDeleting = false;
				this.isConfirmDeleteVisible = false;
				this.isConfirmDeleteMobileVisible = false;
				this.closeAllProperties();
				this.closeContextItem = true;
				// re-init item if marker deleted when status is closed
				this.$root.$emit('togglingFolder');
				const type = this.selectedItem && this.selectedItem.type ? this.selectedItem.type : null;
				if (type === 'separator') this.reorder();
				this.selectedItem = null;
			};
			const errorCallback = () => {
				this.isDeleting = false;
			};
			rundownItemsApi.delete(id, callback, errorCallback);
		},
		removeItem(itemId) {
			const index = this.items.findIndex(({ id }) => id === (itemId));
			if (index !== -1) {
				this.items.splice(index, 1);
				this.itemsNotSeparator.splice(index, 1);
			}
		},
		editItem(item) {
			this.closeAllProperties();
			this.selectedItem = duplicateVar(item);
			const type = item.type;
			this.itemTypeVisible(type, false);
		},
		editLtMobile(item) {
			this.selectedItem = duplicateVar(item);
			this.isLowerThirdFormMobileVisible = true;
		},
		duplicateItem(item) {
			this.isDuplicating = true;
			// this.closeAllProperties();
			const orderSelectedItem = item && item.order ? item.order : null;

			const label = `Copy of ${item.name}`;
			const params = {
				name: label,
				type: item.type,
				content: item.content,
				layer_index: item.layer_index,
				status: '',
				is_play_live: 0,
				is_play_preview: 0,
				rundown_id: this.rundownId,
				is_shy: item.is_shy,
			};
			const callback = (response) => {
				const item = response.data;
				if (item) this.editItem(item);
				// this.reorderItems();
				this.isDuplicating = false;
			};
			const errorCallback = () => {
				this.isDuplicating = false;
			};
			if (orderSelectedItem) {
				params.order = orderSelectedItem;
			} else {
				params.order = this.items.length + 1;
			}
			rundownItemsApi.create(params, callback, errorCallback);
		},
		iframeUrl(status) {
			const appUrl = process.env.VUE_APP_URL;
			const slug = this.$route.params.slug;
			return `${appUrl}/${status}/${slug}`;
		},
		exportItems() {
			// only array possible
			if (this.items.length !== 0) {
				const rundownItems = duplicateVar(this.items);
				const params = [];
				for (let index = 0; index < rundownItems.length; index++) {
					const currentContent = rundownItems[index].content ? JSON.parse(rundownItems[index].content) : '';
					const parentItem = rundownItems.find(item => item.id === currentContent.parentItem);
					const onCompleteItem = rundownItems.find(item => item.id === currentContent.onCompleteItem);
					const groupItem = rundownItems.find(item => parseInt(item.id) === parseInt(rundownItems[index].group_id));

					const element = {
						id: index,
						name: rundownItems[index].name ? csvInjection(rundownItems[index].name) : '',
						type: rundownItems[index].type ? rundownItems[index].type : '',
						is_play_live: rundownItems[index].is_play_live ? rundownItems[index].is_play_live : 0,
						is_play_preview: rundownItems[index].is_play_preview ? rundownItems[index].is_play_preview : 0,
						is_shy: rundownItems[index].is_shy ? rundownItems[index].is_shy : 0,
						is_locked: rundownItems[index].is_locked ? rundownItems[index].is_locked : 0,
						play_time: rundownItems[index].play_time ? rundownItems[index].play_time : '',
						order: rundownItems[index].order ? rundownItems[index].order : '',
						layer_index: rundownItems[index].layer_index ? rundownItems[index].layer_index : 1,
						parent_name: parentItem ? parentItem.name : null,
						on_complete_name: onCompleteItem ? onCompleteItem.name : null,
						content: rundownItems[index].content ? rundownItems[index].content : '',
						group_name: groupItem ? groupItem.name : null,
					};
					params.push(element);
				}
				const rundownItemsJSON = params;
				const rundownItemsData = XLSX.utils.json_to_sheet(rundownItemsJSON);
				// // A workbook is the name given to an Excel file
				const wb = XLSX.utils.book_new(); // make Workbook of Excel
				const sheetName = this.rundownName;
				const fileName = `${sheetName}.xlsx`;
				// // add Worksheet to Workbook
				// // Workbook contains one or more worksheets
				XLSX.utils.book_append_sheet(wb, rundownItemsData, fileName); // sheetAName is name of Worksheet
				// export Excel file
				XLSX.writeFile(wb, fileName); // name of the file is 'book.xlsx'
			} else {
				this.$notify({
					group: 'Notification',
					type: 'error',
					title: this.$t('Error'),
					text: this.$t('You have nothing to export!'),
				});
			}
		},
		onKeywordChange() {
			// delay(() => {
			// 	this.fetchItems(true);
			// }, 500);
		},
		resetPreview() {
			const slug = this.$route.params.slug;
			// this.isExporting = true;
			const callback = () => {
				// downloadBlob(response, { name: this.$t('Rundown Items'), type });
				// this.isExporting = false;
			};
			const errorCallback = () => {
				// this.isExporting = false;
			};
			rundownItemsApi.resetPreview(atob(slug), callback, errorCallback);
		},
		onStopAll(items) {
			for (let index = 0; index < items.length; index++) {
				const tmpItem = this.items.find(item => item.id === items[index].id);
				if (tmpItem && !tmpItem.is_locked) {
					tmpItem.is_play_live = 0;
					tmpItem.is_play_preview = 0;
				}
			}
		},
		onStopAllLive(items) {
			for (let index = 0; index < items.length; index++) {
				const tmpItem = this.items.find(item => item.id === items[index].id);
				if (tmpItem && !tmpItem.is_locked) {
					tmpItem.is_play_live = 0;
				}
			}
		},
		onStopAllPreview(items) {
			for (let index = 0; index < items.length; index++) {
				const tmpItem = this.items.find(item => item.id === items[index].id);
				if (tmpItem && !tmpItem.is_locked) {
					tmpItem.is_play_preview = 0;
				}
			}
		},
		stopAllLive() {
			this.isStopping = true;
			const callback = () => {
				this.isStopping = false;
			};
			const errorCallback = () => {
				this.isStopping = false;
			};
			rundownsApi.stopLive(atob(this.slug), callback, errorCallback);
		},
		stopAllPreview() {
			this.isStopping = true;
			const callback = () => {
				this.isStopping = false;
			};
			const errorCallback = () => {
				this.isStopping = false;
			};
			rundownsApi.stopPreview(atob(this.slug), callback, errorCallback);
		},
		stopAllAction() {
			if (!this.smallScreen) {
				this.showModalConfirmStopAllDesktop = true;
			} else {
				this.showModalConfirmStopAll = true;
			}
		},
		stopAll() {
			this.isStopping = true;
			const callback = () => {
				this.isStopping = false;
				this.showModalConfirmStopAll = false;
				this.showModalConfirmStopAllDesktop = false;
			};
			const errorCallback = () => {
				this.isStopping = false;
				this.showModalConfirmStopAll = false;
				this.showModalConfirmStopAllDesktop = false;
			};
			rundownsApi.stop(atob(this.slug), callback, errorCallback);
		},
		copyStopUrl(status) {
			const callback = (response) => {
				const url = response.url;
				copyToClipboard(url);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Rundown URL',
					text: 'Stop All URL Copied to clipboard',
				});
				this.stopAllOpened = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown URL',
					text: message,
				});
				this.stopAllOpened = false;
			};
			rundownItemsApi.accessItemLink(this.rundown.id, status, callback, errorCallback);
		},
		joinSocket() {
			if (this.activeRouteSlug) {
				const roomId = `rundown_${atob(this.activeRouteSlug)}`;
				this.$socket.client.emit('join', roomId);
				const payload = {
					rundown_id: this.rundown.id,
					rundown_slug: this.rundown.slug,
					user_id: this.user.id,
				};
				this.$socket.client.emit('editing_asset', payload);
			}
		},
		leaveSocket() {
			if (this.activeRouteSlug) {
				const roomId = `rundown_${atob(this.activeRouteSlug)}`;
				this.$socket.client.emit('leave', roomId);
			}
		},
		async reorder() {
			let items = [].concat(this.items);
			let itemsParam = {};
			let arrayOfItemWithSameGroupId = [];
			let groupItemBeforeAset = [];
			let insertAtIndex = 0;
			// calculate grouping after marker is dragged
			if (this.idItemAfterDrag) {
				const isFolderVisibleResult = localStorage.getItem(`is_folder_visible_${this.idItemAfterDrag}`) ? localStorage.getItem(`is_folder_visible_${this.idItemAfterDrag}`) : 'opened'; // get marker data opened or closed
				insertAtIndex = items.findIndex(({ id }) => id === parseInt(this.idItemAfterDrag)); // find the index where is marker placed on UI
				arrayOfItemWithSameGroupId = items.filter(item => parseInt(item.group_id) === parseInt(this.idItemAfterDrag)); // grouping items that have a group id same as with the marker id
				// check if before aset is separator
				if (items[insertAtIndex - 1] && items[insertAtIndex - 1].type === 'separator') {
					// check if there is closed separator and have one more item
					if (isFolderVisibleResult === 'closed') groupItemBeforeAset = items.filter(item => parseInt(item.group_id) === parseInt(items[insertAtIndex - 1].group_id));
					// check if separator is opened
					if (isFolderVisibleResult === 'opened') {
						items = items.filter(item => parseInt(item.group_id) !== parseInt(this.idItemAfterDrag)); // grouping items that have not a group id same as with the marker id
						// this condition for make sure separator allways on first element
						if (arrayOfItemWithSameGroupId[0].type !== 'separator') {
							arrayOfItemWithSameGroupId.splice(0, 0, arrayOfItemWithSameGroupId.pop());
						}
						// this condition is to decide where the marker moving, top or bottom,
						// if marker goint to top, marker should be placing on index + 1Asset Marker as Group/Folder
						if (this.positionItemDirection === 'top') {
							groupItemBeforeAset = items.filter(item => parseInt(item.group_id) === parseInt(items[insertAtIndex - 1].group_id));
							// eslint-disable-next-line
							insertAtIndex = insertAtIndex + groupItemBeforeAset.length - 1;
						} else if (this.positionItemDirection === 'bottom') {
							groupItemBeforeAset = items.filter(item => parseInt(item.group_id) === parseInt(items[insertAtIndex - 1].group_id));
							// eslint-disable-next-line
							insertAtIndex = insertAtIndex + (groupItemBeforeAset.length - arrayOfItemWithSameGroupId.length);
						}
						items.splice(insertAtIndex, 0, ...arrayOfItemWithSameGroupId); // placing group items to items after calculating
					}
				}
				// check if after asset is separator
				if (items[insertAtIndex + 1] && items[insertAtIndex + 1].type === 'separator') {
					if (isFolderVisibleResult === 'opened') {
						items = items.filter(item => parseInt(item.group_id) !== parseInt(this.idItemAfterDrag));
						// this condition for make sure separator allways on first element
						if (arrayOfItemWithSameGroupId[0].type !== 'separator') {
							arrayOfItemWithSameGroupId.splice(0, 0, arrayOfItemWithSameGroupId.pop());
						}
						// this condition is to decide where the marker moving, top or bottom,
						// if marker goint to top, marker should be placing on index + 1Asset Marker as Group/Folder
						if (this.positionItemDirection === 'top') {
							// eslint-disable-next-line
							insertAtIndex = insertAtIndex - 1;
						} else if (this.positionItemDirection === 'bottom') {
							// eslint-disable-next-line
							insertAtIndex = insertAtIndex - arrayOfItemWithSameGroupId.length;
						}
						items.splice(insertAtIndex + 1, 0, ...arrayOfItemWithSameGroupId); // placing group items to items after calculating
					}
				}
				if (insertAtIndex === 0 || insertAtIndex === (items.length - 1) || (isFolderVisibleResult === 'closed')) {
					items = items.filter(item => parseInt(item.group_id) !== parseInt(this.idItemAfterDrag));
					// this condition for make sure separator allways on first element
					if (arrayOfItemWithSameGroupId[0].type !== 'separator') {
						arrayOfItemWithSameGroupId.splice(0, 0, arrayOfItemWithSameGroupId.pop());
					}
					// this condition is to decide where the marker moving, top or bottom,
					// if marker goint to bottom, marker should be placing on index + total items who have same group_id with marker item
					if (this.positionItemDirection === 'bottom' && isFolderVisibleResult === 'closed') {
						insertAtIndex = insertAtIndex - arrayOfItemWithSameGroupId.length + 1;
					}
					if (groupItemBeforeAset.length > 0) {
						insertAtIndex = insertAtIndex + groupItemBeforeAset.length - 1;
					}
					items.splice(insertAtIndex, 0, ...arrayOfItemWithSameGroupId);
				}
			}
			this.$root.$emit('togglingFolder');
			// next step is adding group_id based on the market above it
			// eslint-disable-next-line
			const ids = items.map(({ id, group_id }) => ({ id, group_id })); // mapping id and group_id
			// replace group id base on marker order
			let currentGroupId = 0;
			let closedCurrentGroupId = 0;
			// iterate all item, and checking there is item those who still don't have group id
			for (let index = 0; index < ids.length; index++) {
				const element = ids[index];
				const isFolderVisible = localStorage.getItem(`is_folder_visible_${element.group_id}`) ? localStorage.getItem(`is_folder_visible_${element.group_id}`) : 'opened';
				if (parseInt(element.id) === parseInt(element.group_id) && isFolderVisible === 'opened') {
					currentGroupId = element.group_id;
				} else if (parseInt(element.id) === parseInt(element.group_id) && isFolderVisible === 'closed') {
					closedCurrentGroupId = element.group_id;
					insertAtIndex = index;
					// eslint-disable-next-line
					arrayOfItemWithSameGroupId = items.filter(item => item.group_id === closedCurrentGroupId);
					// eslint-disable-next-line
					items = items.filter(item => item.group_id !== closedCurrentGroupId);
					items.splice(insertAtIndex, 0, ...arrayOfItemWithSameGroupId);
				} else if (parseInt(element.id) !== parseInt(element.group_id) && parseInt(element.group_id) !== parseInt(closedCurrentGroupId)) {
					element.group_id = currentGroupId;
				}
			}
			this.items = items;
			// start reordering
			itemsParam = ids;
			const resutlItems = itemsParam;
			this.itemsWithGroupId = resutlItems;
			const callback = () => {
			};
			const errorCallback = () => {};
			const params = {
				items: JSON.stringify(resutlItems),
				rundown_slug: atob(this.slug),
				user_id: this.user.id,
			};
			rundownItemsApi.reorder(params, callback, errorCallback);
		},
		createBulk(items) {
			this.isImporting = true;
			const rundownId = this.rundown.id;
			const callback = (response) => {
				const importedItems = response.data;
				for (let index = 0; index < importedItems.length; index++) {
					const item = importedItems[index];
					this.items.push(item);
				}
				this.isImporting = false;
				const message = this.$t('Import Success');
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Rundown Assets',
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Item',
					text: message,
				});
				this.isImporting = false;
			};
			rundownItemsApi.createBulk(rundownId, items, callback, errorCallback);
		},
		openConfirmDeleteAll() {
			this.settingsOpened = false;
			for (let index = 0; index < this.items.length; index++) {
				const itemId = this.items[index].id;
				this.rundownItems.push(itemId);
			}
			this.isConfirmClearAll = true;
		},
		closeConfirmDeleteAll() {
			this.rundownItems = [];
			this.isConfirmClearAll = false;
		},
		bulkDelete() {
			this.isDeletingAllRundown = true;
			const callback = (response) => {
				const message = response.message;
				const rundownItems = response.data;

				for (let index = 0; index < rundownItems.length; index++) {
					const rundownItem = rundownItems[index];
					const rundownItemIndex = this.items.findIndex(({ id }) => id === rundownItem);
					if (rundownItemIndex !== -1) this.items.splice(rundownItemIndex, 1);
				}

				this.rundownItems = [];
				this.isDeletingAllRundown = false;
				this.isConfirmClearAll = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Rundown Assets',
					text: message,
				});
				this.closeAllProperties();
			};
			const errorCallback = () => {
				this.isDeletingAllRundown = false;
			};
			const tmpRundownItems = duplicateVar(this.rundownItems);
			rundownItemsApi.bulkDelete(tmpRundownItems, callback, errorCallback);
		},
		onImportSelected(e) {
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].name.includes('.xlsx') || files[0].name.includes('.xls')) {
					const file = files[0];
					const reader = new FileReader();
					reader.onload = (e) => {
						const data = e.target.result;
						try {
							const workbook = XLSX.read(data, {
								type: 'binary',
							});
							workbook.SheetNames.forEach((sheetName) => {
								// Here is your object
								const XlRowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
								this.createBulk(XlRowObject);
							});
						} catch (error) {
							this.$notify({
								group: 'app',
								type: 'warning',
								title: 'Upload Media',
								text: 'File Corrupt, cannot read data',
							});
						}
					};
					// eslint-disable-next-line no-unused-vars
					reader.onerror = (ex) => {
					};
					reader.readAsBinaryString(file);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		insertItems(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.insertItem(item, false);
			}
		},
		closeDisplayCache() {
			this.displayCacheList = [];
			this.isShowDisplayCache = false;
		},
		insertDisplays(items) {
			const tmpItems = duplicateVar(items);
			const index = this.displayCacheList.findIndex(({ id }) => id === items.id);
			if (index === -1) {
				const displayCountItem = 1;
				tmpItems.count_item = displayCountItem;
				this.displayCacheList.push(tmpItems);
			} else {
				if (this.hasProperty(this.displayCacheList[index], 'count_item')) {
					const displayCountItem = this.displayCacheList[index].count_item + 1;
					tmpItems.count_item = displayCountItem >= this.printMediasLength(tmpItems.items) ? this.printMediasLength(tmpItems.items) : displayCountItem;
				}
				this.$set(this.displayCacheList, index, tmpItems);
			}
		},
		printMediasLength(items) {
			const medias = items.filter(item => ((item.type === 'image' || item.type === 'video' || item.type === 'lottie' || item.type === 'lower_third')));
			return medias.length;
		},
		insertItem(item, isReset = true) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				// this.items.push(item);
				if (isReset) this.items.splice(item.order, 0, item);
				if (item.type !== 'separator') {
					this.itemsNotSeparator.splice(item.order, 0, item);
				}
				if (isReset) this.reorder();
			} else {
				this.$set(this.items, index, item);
				// eslint-disable-next-line no-lonely-if
				if (item.type !== 'separator') {
					this.$set(this.itemsNotSeparator, index, item);
				}
			}
		},
		setSelectedItem(item) {
			this.closeAllProperties();
			this.selectedItem = duplicateVar(item);
			this.itemTypeVisible(item.type);
		},
		initKeyboardHandler() {
			document.addEventListener('keydown', this.keyHandler);
		},
		removeEventKeyboadHandler() {
			document.removeEventListener('keydown', this.keyHandler);
		},
		keyHandler(e) {
			const keyDeleteItem = e.keyCode === 8 || e.keyCode === 46;
			const keyForceDeleteItem = (e.shiftKey && e.keyCode === 8) || (e.shiftKey && e.keyCode === 46);
			if (keyForceDeleteItem) {
				if (this.isHoverOnTheList && !this.isFocusOnSearch && this.isClickItem) this.deleteItem(this.selectedItem);
			} else if (keyDeleteItem) {
				if (this.isHoverOnTheList && !this.isFocusOnSearch && this.isClickItem) this.confirmDeleteItem(this.selectedItem);
			}
		},
		addBodyClass() {
			document.body.classList.add('rundown-editor');
		},
		removeBodyClass() {
			document.body.classList.remove('rundown-editor');
		},
		sortItemOnMacros(macroItems) {
			// eslint-disable-next-line
			macroItems.sort((a, b) => {
				return a.order - b.order;
			});
			return macroItems;
		},
		fetchMacros() {
			this.isFetchingMacros = true;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'order',
				sort_by: 'asc',
				rundown_id: this.rundownId,
			};
			const callback = (response) => {
				const macros = response.data;
				this.macros = macros;
				for (let index = 0; index < this.macros.length; index++) {
					this.sortItemOnMacros(this.macros[index].macroItems);
				}
				this.isFetchingMacros = false;
			};
			const errorCallback = () => {
				this.isFetchingMacros = false;
			};
			macrosApi.getList(params, callback, errorCallback);
		},
		fetchMacrosById(macro) {
			this.isFetchingMacros = true;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'order',
				sort_by: 'asc',
				macro_id: macro.id,
			};
			const callback = () => {
				// const macros = response.data;
				// this.macrosById = macros;
				this.isFetchingMacros = false;
			};
			const errorCallback = () => {
				this.isFetchingMacros = false;
			};
			macrosItemsApi.getList(params, callback, errorCallback);
		},
		addMacro() {
			this.isAddingMacro = true;
			const totalMacros = this.macros.length + 1;
			const defaultMacroName = `Macro Command ${totalMacros}`;
			const params = {
				name: defaultMacroName,
				rundown_id: this.rundownId,
			};
			const callback = (response) => {
				const macro = response.data;
				this.macros.push(macro);
				this.selectedMacro = macro;
				this.isMacroVisible = true;
				this.isAddingMacro = false;
			};
			const errorCallback = () => {
				this.isAddingMacro = false;
			};
			if (this.macros.length < 14) {
				macrosApi.create(params, callback, errorCallback);
			} else {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Macros',
					text: 'You have reach the Limit (14 Macros)',
				});
				this.isAddingMacro = false;
			}
		},
		insertMacro(macro) {
			const index = this.macros.findIndex(({ id }) => id === macro.id);
			if (index === -1) this.macros.push(macro);
			else this.$set(this.macros, index, macro);
		},
		updateMacro(macroItems) {
			const macroId = macroItems && macroItems.length >= 0 ? macroItems[0].macro_id : null;
			if (macroId) {
				const index = this.macros.findIndex(({ id }) => id === macroId);
				if (index !== -1) this.macros[index].macroItems = duplicateVar(macroItems);
			}
			this.fetchMacros(); // for update macroItems inside macro (optimize in the future)
		},
		removeMacro(macro) {
			const index = this.macros.findIndex(({ id }) => id === macro.id);
			if (index !== -1) this.macros.splice(index, 1);
			this.isMacroVisible = false;
			this.selectedMacro = null;
		},
		showMacro(macro) {
			this.opened = false;
			this.selectedMacro = macro;
			this.isMacrosListVisible = false;
			this.isMacroVisible = true;
			this.isHoverOnTheList = false;
		},
		copyPlayMacro(macro) {
			const callback = (response) => {
				const url = response.url;
				copyToClipboard(url);
				const message = this.$t('Play URL Copied to clipboard');
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Item URL',
					text: message,
				});
				this.opened = false;
			};
			const errorCallback = () => {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Item URL',
					text: 'Failed to copy URL',
				});
				this.opened = false;
			};
			macrosApi.playItemLink(macro.id, atob(this.slug), callback, errorCallback);
		},
		playMacro(macro) {
			this.macroPlaying = macro;
			const macroItems = macro && macro.macroItems && macro.macroItems.length > 0 ? macro.macroItems : null;
			if (macroItems) {
				this.macroActiveId = macro.id;
				const items = macroItems;
				this.isPlayingMacroListDone = false;
				this.startMacroitems(items, this.macroPlaying);
			} else {
				this.$notify({
					group: 'app',
					type: 'warning',
					title: 'Macros',
					text: 'Command is failed to execute',
				});
			}
		},
		sleep(ms) {
			return new Promise(
				resolve => setTimeout(resolve, ms),
			);
		},
		async startMacroitems(items, macro) {
			for (let index = 0; index < items.length; index++) {
				let delay = 0;
				if (items[index].delay) {
					delay = parseInt(items[index].delay);
				} else {
					delay = 0;
				}
				// eslint-disable-next-line
				await this.sleep(delay); // delay each loop
				this.isPlayingMacroListDone = false; // set status macro as playing
				const item = items[index]; // get current item
				// getting item previous in macro list
				if (item && item.status === 'play_previous') { // condition  on play previous
					const tmpIndex = index; // set index in temp variable
					this.itemAfterPrevious = items[tmpIndex - 1]; // set previous item
					// prevent if prevoius items in macro list is not the assets item
					if (this.itemAfterPrevious && !this.itemAfterPrevious.rundownItem) this.itemAfterPrevious = items[tmpIndex - 2];
					if (this.itemAfterPrevious && !this.itemAfterPrevious.rundownItem) this.itemAfterPrevious = items[tmpIndex - 3];
					if (this.itemAfterPrevious && !this.itemAfterPrevious.rundownItem) this.itemAfterPrevious = items[tmpIndex - 4];
					// find the item that have the rundown_item_id
					const resultItemMacro = this.itemAfterPrevious && this.itemAfterPrevious.rundown_item_id ? this.itemAfterPrevious.rundown_item_id : '';
					const itemsParent = this.filteredItems;
					if (resultItemMacro) {
						// send the id of previous item
						const indexItemsParent = itemsParent.findIndex(({ id }) => id === resultItemMacro);
						if (itemsParent[indexItemsParent - this.minusIndexParent]) item.rundown_item_id = itemsParent[indexItemsParent - this.minusIndexParent].id;
					}
				}
				// getting item next in macro list
				if (item && item.status === 'play_next') {
					const tmpIndex = index;
					this.itemBeforenext = items[tmpIndex - 1];
					// prevent if prevoius items in macro list is not the assets item
					if (this.itemBeforenext && !this.itemBeforenext.rundownItem) this.itemBeforenext = items[tmpIndex - 2];
					if (this.itemBeforenext && !this.itemBeforenext.rundownItem) this.itemBeforenext = items[tmpIndex - 3];
					if (this.itemBeforenext && !this.itemBeforenext.rundownItem) this.itemBeforenext = items[tmpIndex - 4];
					// find the item that have the rundown_item_id
					const resultItemMacro = this.itemBeforenext && this.itemBeforenext.rundown_item_id ? this.itemBeforenext.rundown_item_id : '';
					const itemsParent = this.filteredItems;
					if (resultItemMacro) {
						// send the id of next item
						const indexItemsParent = itemsParent.findIndex(({ id }) => id === resultItemMacro);
						if (itemsParent[indexItemsParent + this.plusIndexParent]) item.rundown_item_id = itemsParent[indexItemsParent + this.plusIndexParent].id;
					}
				}
				// playin every item macro list
				this.startMacroItem(item);
			}
			// set to idle after playing is done
			this.macroPlaying = macro;
			this.macroPlaying.status = 'idle';
			// reset value
			this.macroActiveId = null;
			this.isPlayingMacroListDone = true;
			this.minusIndexParent = 1;
			this.plusIndexParent = 1;
		},
		startMacroItem(item) {
			if (item && item.layer_index) this.updateLayerIndexByMacro(item);
			let rundownItemId = item.rundown_item_id;
			const action = item.status;
			if (action === 'play') {
				// start playing new item
				const callback = () => {
				};
				const errorCallback = () => {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Macros',
						text: 'Command is failed to execute',
					});
				};
				rundownItemsApi.playLive(rundownItemId, callback, errorCallback);
				this.minusIndexParent = 1;
				this.plusIndexParent = 1;
			} else if (action === 'force_play') {
				const callback = () => {
				};
				const errorCallback = () => {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Macros',
						text: 'Command is failed to execute',
					});
				};
				rundownItemsApi.forcePlay(rundownItemId, callback, errorCallback);
				this.minusIndexParent = 1;
				this.plusIndexParent = 1;
			} else if (action === 'stop') {
				const callback = () => {
				};
				const errorCallback = () => {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Macros',
						text: 'Command is failed to execute',
					});
				};
				rundownItemsApi.stopLive(rundownItemId, callback, errorCallback);
				this.minusIndexParent = 1;
				this.plusIndexParent = 1;
			} else if (action === 'hide') {
				const callback = () => {
				};
				const errorCallback = () => {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Macros',
						text: 'Command is failed to execute',
					});
				};
				rundownItemsApi.hideLive(rundownItemId, callback, errorCallback);
				this.minusIndexParent = 1;
				this.plusIndexParent = 1;
			} else if (action === 'show') {
				const callback = () => {
				};
				const errorCallback = () => {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Macros',
						text: 'Command is failed to execute',
					});
				};
				rundownItemsApi.showLive(rundownItemId, callback, errorCallback);
				this.minusIndexParent = 1;
				this.plusIndexParent = 1;
			} else if (action === 'stop_all') {
				this.stopAllLive(item);
				this.minusIndexParent = 1;
				this.plusIndexParent = 1;
			} else if (action === 'clear_output') {
				this.stopAll(item);
				this.minusIndexParent = 1;
				this.plusIndexParent = 1;
			} else if (action === 'play_next') {
				/* eslint-disable */
				if (!rundownItemId) {
					// finding last index on items with status live
						const filterPlayingItem = item => (item.is_play_live === 1);
						const resulfilterPlayingItem = this.filteredItems.filter(filterPlayingItem);
						const lastIndex = resulfilterPlayingItem[resulfilterPlayingItem.length - 1];
						const lastIndexId = lastIndex && lastIndex.id ? lastIndex.id : '';
						// find the item with status playing (live)
						const index = this.filteredItems.findIndex(({ id }) => id === lastIndexId);
						const currentPlay = this.filteredItems[index] && this.filteredItems[index].id ? this.filteredItems[index].id : '';
						const indexPlay = this.filteredItems.findIndex(({ id }) => id === currentPlay);
						// command the next item to playing
						rundownItemId = this.filteredItems[indexPlay + 1] && this.filteredItems[indexPlay + 1].id ? this.filteredItems[indexPlay + 1].id : '';
					if (index >= 0) {
						const callback = () => {
						};
						const errorCallback = () => {
							this.$notify({
								group: 'app',
								type: 'error',
								title: 'Macros',
								text: 'Command is failed to execute',
							});
	
						};
						rundownItemsApi.playLive(rundownItemId, callback, errorCallback);
					}
				} else {
					const callback = () => {
					};
					const errorCallback = () => {
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Macros',
							text: 'Command is failed to execute',
						});

					};
					rundownItemsApi.playLive(rundownItemId, callback, errorCallback);
					this.plusIndexParent++;
					this.minusIndexParent = 1;
				}
			} else if (action === 'play_previous') {
				if (!rundownItemId) {
					// find the item with status playing (live)
					const index = this.filteredItems.findIndex(({ is_play_live }) => is_play_live === 1);
					const currentPlay = this.filteredItems[index] && this.filteredItems[index].id ? this.filteredItems[index].id : '';
					const indexPlay = this.filteredItems.findIndex(({ id }) => id === currentPlay);
					// command the previous item to playing
					rundownItemId = this.filteredItems[indexPlay - 1] && this.filteredItems[indexPlay - 1].id ? this.filteredItems[indexPlay - 1].id : '';
					const callback = () => {
					};
					const errorCallback = () => {
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Macros',
							text: 'Command is failed to execute',
						});

					};
					rundownItemsApi.playLive(rundownItemId, callback, errorCallback);
				} else {
					/* eslint-enable */
					const callback = () => {
					};
					const errorCallback = () => {
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Macros',
							text: 'Command is failed to execute',
						});
					};
					rundownItemsApi.playLive(rundownItemId, callback, errorCallback);
					this.plusIndexParent = 1;
				}
			}
		},
		updateLayerIndexByMacro(item) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const params = {
				layer_index: item.layer_index,
			};
			rundownItemsApi.update(item.rundown_item_id, params, callback, errorCallback);
		},
		showMacrosList() {
			this.isMacrosListVisible = true;
		},
		focusOnSearch(isFocus) {
			this.isFocusOnSearch = isFocus;
		},
		onMacrosOrderChanged() {
			const ids = this.macros.map(({ id }) => id);
			macrosApi.reorder(ids);
		},
		onMacroDuplicated(macro) {
			this.isMacroVisible = false;
			this.selectedMacro = null;
			this.showMacro(macro);
			this.opened = false;
			this.macros.push(macro);
		},
		confirmRemoveVisibleMacro(macro) {
			this.opened = false;
			this.selectedMacro = macro;
			this.isConfirmRemoveVisibleMacro = true;
			this.macroName = macro.name;
			this.macroId = macro.id;
		},
		deleteMacro() {
			this.isRemoving = true;
			const callback = () => {
				this.isRemoving = false;
				this.removeMacro(this.selectedMacro);
				this.isConfirmRemoveVisibleMacro = false;
			};
			const errorCallback = () => {
				this.isRemoving = false;
			};
			macrosApi.delete(this.macroId, callback, errorCallback);
		},
		duplicate(macro) { // duplicate macro
			this.isDuplicating = true;
			const name = `${this.$t('Duplicate of')} ${macro.name}`;
			const params = {
				name,
				rundown_id: this.rundown.id,
			};
			const callback = (response) => {
				const newMacro = response.data;
				const msg = response.message;
				this.duplicateMacroitems(newMacro, macro);
				// this.macros.push(macroItem);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Macros',
					text: msg,
				});
			};
			const errorCallback = () => {
				this.isDuplicating = false;
			};
			if (this.macros.length < 14) {
				macrosApi.create(params, callback, errorCallback);
			} else {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Macros',
					text: 'You have reach the Limit (14 Macros)',
				});
			}
		},
		duplicateMacroitems(newMacro, macro) {
			const macroItems = macro && macro.macroItems ? macro.macroItems : null;
			const callback = () => {
				this.onMacroDuplicated(newMacro);
			};
			const errorCallback = () => {
			};

			const params = {
				macroItems: JSON.stringify(macroItems),
				macro_id: newMacro.id,
			};
			macrosItemsApi.createBulk(params, callback, errorCallback);
		},
		initMainWidth() {
			const main = this.$refs.editorMain;
			const width = main && main.offsetWidth ? main.offsetWidth : '';
			this.mainWidth = width;
		},
		onResize() {
			this.initMainWidth();
		},
		onClick(e) {
			const target = e.target.id;
			if ((this.elementId !== target)) this.opened = false;
		},
		onClickAdd(e) {
			const target = e.target.id;
			if ((this.elementIdAdd !== target)) {
				this.addOpened = false;
				this.settingsOpened = false;
				this.filterOpened = false;
			}
		},
		onClickStopAll(e) {
			const el = this.$refs.dropdownContextStopAll;
			const isElementExist = el && el !== undefined;
			const target = e.target;
			if (e.target && isElementExist) {
				if ((el !== target) && !el.contains(target)) this.stopAllOpened = false;
			}
		},
		handleScroll(e) {
			const scrollPos = e.target.scrollTop;
			if (scrollPos > 5) {
				this.isScrollItem = true;
			} else {
				this.isScrollItem = false;
			}
		},
		updateActiveUsers() {
			const callback = () => {
			};
			const errorCallback = () => {
				if (this.activeRouteName !== 'Rundowns') {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Rundown Assets',
						text: 'please contact support!',
					});
				}
			};
			let currentActiveUsers = duplicateVar(this.activeUsers);
			const item = {
				id: this.user.id,
				name: this.user.name,
			};
			if (currentActiveUsers && currentActiveUsers.length >= 1) {
				const index = currentActiveUsers.findIndex(({ id }) => id === this.user.id);
				if (index !== -1) {
					currentActiveUsers.splice(item, 1);
				}
			} else {
				currentActiveUsers = [item];
			}
			const params = {
				active_users: JSON.stringify(currentActiveUsers),
			};
			rundownsApi.update(this.rundownId, params, callback, errorCallback);
		},
		// method for checking user click list rundown editor or asset property
		unClickedListRundownItem() {
			this.isClickItem = false;
		},
		clickItem(status) {
			if (status) {
				this.isClickItem = true;
			} else {
				this.isClickItem = false;
			}
		},
		showModalName(str) {
			return elpisisString(str);
		},
		updateItemsOrder(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				const itemIndex = this.items.findIndex(current => current.id === item.id);
				if (itemIndex !== -1) Object.assign(this.items[itemIndex], item);
			}
		},
		// reorderItems(items) {
		// 	const ids = items.map(({ id }) => id);
		// 	const callback = (response) => {
		// 		this.updateItemsOrder(response.data);
		// 	};
		// 	const errorCallback = () => {
		// 	};
		// 	rundownItemsApi.reorder(ids, callback, errorCallback);
		// },
		onResizeWidth() {
			this.calcWidth = window.innerWidth;
			if (window.innerWidth <= 1024) {
				this.smallScreen = true;
			} else {
				this.smallScreen = false;
			}
		},
		receiveMessage(event) {
			if (event && event.data && event.data.length > 0) {
				const data = event && event.data && event.data.includes('{') ? JSON.parse(event.data) : null;
				if (data && data.data === 'invalidiframe') {
					this.$notify({
						group: 'app',
						type: 'error',
						duration: 999999999,
						text: `We can't connect to the server at <a>${data && data.url ? data.url : ''}</a>`,
					});
				}
			}
		},
		async filteredLowerThirdTemplates(templates) {
			const pr = new Promise((resolve, reject) => {
				try {
					let templatesResult = templates[0] || null;
					templatesResult = templates.length !== 0 ? this.templates.filter(t => t.type === 'lower_third') : [];
					if (templates.length === 0) {
						reject(console.log('Template unavailable'));
					}
					resolve(templatesResult[Math.floor(Math.random() * templatesResult.length)]);
				} catch (e) {
					reject(e);
				}
			});
			return pr;
		},
		async filteredTickerTemplates(templates) {
			const pr = new Promise((resolve, reject) => {
				try {
					let templatesResult = templates[0] || null;
					templatesResult = templates.length !== 0 ? this.templatesTicker.filter(t => t.type === 'ticker') : [];
					if (templates.length === 0) {
						reject(console.log('Template unavailable'));
					}
					resolve(templatesResult[Math.floor(Math.random() * templatesResult.length)]);
				} catch (e) {
					reject(e);
				}
			});
			return pr;
		},
		beforeUnload(event) {
			event.preventDefault();
			const dialogText = 'We are saving the status of your listing. Are you realy sure you want to leave?';
			// eslint-disable-next-line no-param-reassign
			event.returnValue = dialogText;
			return dialogText;
		},
		copyURLitem(status) {
			// if (status === 'play') {
			const callback = (response) => {
				const url = response.url;
				const message = response.message;
				copyToClipboard(url);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Item URL',
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Item URL',
					text: message,
				});
				this.opened = false;
			};
			rundownItemsApi.accessItemLink(this.rundownId, status, callback, errorCallback);
		},
		goToCommandRundown() {
			const route = `/rundowns/command/editor/${this.activeRouteSlug}`;
			const routeData = this.$router.resolve(route);
			window.open(routeData.href, '_self');
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		isRtmpApiKeyEnabled() {
			const isApiKey = this.user && this.user.is_api_key_enabled ? this.user.is_api_key_enabled : false;
			return isApiKey;
		},
		activeUsers() {
			const parsedActiveUser = this.rundown
			&& typeof this.rundown.active_users === 'string'
			&& this.rundown.active_users !== '' ? this.rundown.active_users : null;
			return JSON.parse(parsedActiveUser);
		},
		currentActiveUsers() {
			const currentUsers = this.activeUsers && this.activeUsers.length > 0 ? this.activeUsers : null;
			let diffrentUserActive = null;
			if (currentUsers) diffrentUserActive = currentUsers.findIndex(({ id }) => id !== this.user.id);
			return diffrentUserActive;
		},
		userSettings() {
			const userSettings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return userSettings;
		},
		loadingCache() {
			if (this.cachingText.includes('Bottling')) {
				return `${this.cachingText}...`;
			}
			return `${this.cachingText + this.rundownName}...`;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		rundownUserId() {
			return this.rundown && this.rundown.user_id ? this.rundown.user_id : 0;
		},
		filteredItems: {
			get() {
				const keyword = this.keyword.toLowerCase().trim();
				const filter = ({ type, name }) => {
					const isSameType = type === this.filterType || this.filterType === 'all';
					// const isMatchFilterShy = this.filterShy ? !isShy : true;
					const nameLower = name && name !== '' ? name.toLowerCase() : true;
					const isMatchKeyword = nameLower && nameLower !== '' && typeof (nameLower) === 'string' ? nameLower.includes(keyword) : true;
					const isMatch = isSameType && isMatchKeyword;
					return isMatch;
				};
				const filtered = this.items.filter(filter);
				return filtered;
			},
			set(values) {
				this.items = values;
				setTimeout(() => {
					this.reorder();
				}, 100);
			},
		},
		liveUrl() {
			const appUrl = process.env.VUE_APP_URL;
			const slug = this.$route.params.slug;
			return `${appUrl}/live/${slug}`;
		},
		exportParams() {
			const keyword = this.keyword.trim();
			const ids = this.items.map(({ id }) => id);
			const idsJson = JSON.stringify(ids);
			const params = {
				order_by: 'name',
				sort_by: 'asc',
				ids: idsJson,
				rundown_id: this.rundownId,
			};
			if (keyword !== '') params.keyword = keyword;
			return params;
		},
		isEmpty() {
			return this.items.length === 0;
		},
		// display() {
		// 	return this.rundown && this.rundown.display ? this.rundown.display : null;
		// },
		hasShyItems() {
			// eslint-disable-next-line
			const filter = ({ is_shy }) => is_shy === 1 || is_shy === '1';
			return this.items.filter(filter).length > 0;
		},
		displayWidth() {
			const defaultWidth = 1920;
			const displayWidth = this.display && this.display.width ? parseInt(this.display.width) : defaultWidth;
			return displayWidth;
		},
		displayHeight() {
			const defaultHeight = 1080;
			const displayHeight = this.display && this.display.height ? parseInt(this.display.height) : defaultHeight;
			return displayHeight;
		},
		displayRatio() {
			const ratio = this.displayWidth / this.displayHeight;
			return ratio;
		},
		isVertical() {
			const ratio = this.displayHeight > this.displayWidth;
			return ratio;
		},
		previewWidth() {
			if (this.calcWidth > 0) {
				// if ratio Vertical
				if (this.isVertical) {
					// calculate nav height
					const navbarHeight = 57;
					// width
					const viewportWidth = window.innerWidth;
					const paddingRight = 333 + 455; // Side nav + property width
					const mainWidth = viewportWidth - paddingRight;
					const totalDisplay = 2;
					const width = mainWidth / totalDisplay;
					// if portrait
					if (this.displayRatio === 0.8) {
						if (this.previewHeight > width) return width;
						return (width * 0.8) - 40;
					}
					// if landscape
					if (((width - (width - this.previewHeight) + navbarHeight) * 2) > mainWidth) return (mainWidth / 2) + 9;
					return width - (width - this.previewHeight) + navbarHeight;
				}
				// if ratio landscape
				const widthAccordingToHeight = this.previewHeight / (this.displayHeight / this.displayWidth);
				return widthAccordingToHeight;
			}
			const widthAccordingToHeight = this.previewHeight / (this.displayHeight / this.displayWidth);
			return widthAccordingToHeight;
		},
		previewHeight() {
			const viewportHeight = window.innerHeight;
			const navbarHeight = 57;
			const paddingBottom = 10;
			const mainHeight = viewportHeight - navbarHeight - paddingBottom;
			if (this.calcWidth > 0) {
				if (this.displayRatio === 0.8) return mainHeight;
				return mainHeight / 2;
			}
			return mainHeight / 2;
		},
		streamPreviewStyle() {
			const width = this.previewWidth;
			const height = this.previewHeight;
			const style = {
				width: `${width}px`,
				height: `${height}px`,
			};
			// making canvas preview always align vertical center (portrait)
			const containerCanvas = document.getElementById('containerCanvas') && document.getElementById('containerCanvas').clientHeight ? document.getElementById('containerCanvas').clientHeight : '';
			if (this.displayRatio === 0.8) {
				const heightCanvas = (this.previewWidth / 4) * 5;
				style.height = `${heightCanvas}px`;
				if (containerCanvas > heightCanvas) style.marginTop = `${(containerCanvas - heightCanvas) / 2}px`;
			}
			// making canvas preview always align vertical center (vertical landscape)
			if (this.isVertical && this.displayRatio !== 0.8) {
				const heightCanvas = (this.previewWidth / 9) * 16;
				style.height = `${heightCanvas}px`;
				if (containerCanvas > heightCanvas) style.marginTop = `${(containerCanvas - heightCanvas) / 2}px`;
			}
			return style;
		},
		streamWrapperStyle() {
			const displayWidth = this.displayWidth;
			const displayHeight = this.displayHeight;
			let transformScale = 0.3541; // default scale
			transformScale = this.previewWidth / displayWidth;
			const backgroundColor = this.display && this.display.background_color && this.display.background_color !== ''
				? this.display.background_color : '#000';
			const style = {
				width: `${displayWidth}px`,
				height: `${displayHeight}px`,
				transform: `scale(${transformScale})`,
				backgroundColor,
			};
			return style;
		},
		elementId() {
			return 'dropdownContextMacro';
		},
		elementAdd() {
			return 'dropdownContextAdd';
		},
		activeRouteName() {
			return this.$route.name;
		},
		visibleElements() {
			const filter = item => (item && item.is_play_live === 1);
			return this.filteredItems.filter(filter).length;
		},
		activeRouteSlug() {
			const slug = this.$route && this.$route.params && this.$route.params.slug ? this.$route.params.slug : this.slug;
			return slug;
		},
		userRenderSequences() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			const userSubscription = settings && settings.subscription ? settings.subscription : null;
			const renderSequencesSetting = userSubscription && userSubscription.render_png ? userSubscription.render_png : null;
			const isRenderSequencesEnable = renderSequencesSetting && renderSequencesSetting.is_enabled ? renderSequencesSetting.is_enabled : false;
			return isRenderSequencesEnable;
		},
	},
	watch: {
		rundown() {
			if (this.rundown) {
				this.rundownName = this.rundown.name;
				// if (!this.$socket.connected) {
				this.joinSocket();
				// }
				this.fetchItemsNotSeparator();
				this.fetchMacros();
				this.display = localStorage.getItem(`default_output_size_${this.user.id}`) ? JSON.parse(localStorage.getItem(`default_output_size_${this.user.id}`)) : null;
			}
		},
		rundownName(val) {
			this.rundownName = val.replace(/[^A-Z0-9 ]/gi, '');
			document.title = this.rundownName ? `${this.rundownName} - Grafias` : 'Rundown - Grafias';
		},
		// $route: {
		// 	immediate: true,
		// 	handler() {
		// 		delay(() => {
		// 			console.log(this.rundown);

		// 		}, 500);
		// 	},
		// },
	},
	created() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		this.$nextTick(() => {
			this.addBodyClass();
			this.resetPreview();
			this.setDrawerVisible(false);
			this.initData();
			this.initKeyboardHandler();
			this.fetchTemplatesTicker();
		});
		// this.fetchPackage();
		window.addEventListener('resize', this.onResize);
		window.addEventListener('contextmenu', this.onClick);
		window.addEventListener('contextmenu', this.onClickAdd);
		window.addEventListener('contextmenu', this.onClickStopAll);
		// window.onbeforeunload = () => {
		// 	// eslint-disable-next-line no-alert
		// 	alert('are you sure want to close the tab?');
		// };
		window.addEventListener('beforeunload', this.beforeUnload);
		// const isVideo = this.item.type === 'video';
	},
	destroyed() {
		window.removeEventListener('resize', this.onResize);
		window.removeEventListener('contextmenu', this.onClick);
		window.removeEventListener('contextmenu', this.onClickAdd);
		window.removeEventListener('contextmenu', this.onClickStopAll);

		this.leaveSocket();
	},
	beforeDestroy() {
		localStorage.removeItem(`default_render_size_${this.user.id}`);
		this.updateActiveUsers();
		this.removeEventKeyboadHandler();
		this.removeBodyClass();
		this.setDrawerVisible(true);
		window.removeEventListener('message', this.receiveMessage);
		window.removeEventListener('beforeunload', this.beforeUnload);
	},
	mounted() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		this.initMainWidth();
		window.addEventListener('message', this.receiveMessage);
		// communication between any components
	},
};
</script>
